<template>
  <!-- 预配舱单超链接 -->
  <div class="page-container" id="container">
    <scroll-pane ref="statusScrollPane" class="tags-view-wrapper" v-if="false">
      <div v-for="(item, index) in axisStatusList" :key="index">
        <div class="node-content">
          <img
              :src="item.iconStatus[item.index]"
              class="node-content-img"
          />
          <div
              v-if="index !== axisStatusList.length - 1"
              :class="
              item.completeStatus <= completeStatus
                ? 'solid-style'
                : 'dashed-style'
            "
          ></div>
          <div class="node-content-name">{{ item.text[0] }}</div>
          <span class="node-content-date">{{ item.text[1] }}</span>
        </div>
      </div>
    </scroll-pane>
    <el-row>
       <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">舱单导入</span>
                </el-col>
                </div>
        </el-row>
      <el-row class="content-panel">
        <upload-excel :http-request="manifestImport"/>
      </el-row>
    </el-row>
    <!-- 基本信息-start -->
    <edit-from-info
        ref="editFromInfoRef"
        :ebFtPlanEditForm.sync="ebFtPlanEditForm"
        :picker-options="pickerOptions"
        @validateEditFromInfoSuccess="saveAndsubmit"
        :isAddManiFest="isAddManiFest"
        :isAddManiFest1="isAddManiFest1"
        :isAddManiFest2="isAddManiFest2"
        :type="type"
        :notEditable="ebFtPlanEditForm.ebOrder.notEditable"
    />


    <!-- 收发通信息信息-end -->
    <!-- 货物小计-start -->
    <el-form
      ref="cargoStatisticsFormRef"
      :rules="cargoInfoFormRules"
      :model="ebFtPlanEditForm"
      class="form-panel"
      label-position="top"
    >
      <el-row class="panel-top">
        <el-col class="panel-top">
          <el-row class="title-panel-external">
            <div class="title-panel">
              <el-col>
                <span class="title-text">货物小计</span>
              </el-col>
            </div>
          </el-row>
          <el-row class="content-panel">
            <el-col>
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="唛头:" prop="ebFtPlan.marks">
                    <el-input
                      size="mini"
                      type="textarea"
                      :rows="6"
                      case="upper"
                      v-model="ebFtPlanEditForm.ebFtPlan.marks"
                      :title="ebFtPlanEditForm.ebFtPlan.marks"
                      ref="ebFtPlan.marks"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="货物描述:" prop="ebFtPlan.cargoDescription">
                    <el-input
                      size="mini"
                      type="textarea"
                      case="upper"
                      :rows="6"
                      v-model="ebFtPlanEditForm.ebFtPlan.cargoDescription"
                      :title="ebFtPlanEditForm.ebFtPlan.cargoDescription"
                      ref="ebFtPlan.cargoDescription"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-row>
                    <el-col>
                      <el-row :gutter="10">
                        <el-col :span="11">
                          <el-row :gutter="5">
                            <el-col :span="14">
                              <el-form-item label="件数:" prop="ebFtPlan.noOfPackage">
                                <el-input
                                  size="mini"
                                  v-model="ebFtPlanEditForm.ebFtPlan.noOfPackage"
                                  :title="ebFtPlanEditForm.ebFtPlan.noOfPackage"
                                  onkeyup="value=value.replace(/[^\d.]/g,'')"
                                  ref="ebFtPlan.noOfPackage"
                                ></el-input>
                              </el-form-item>
                            </el-col>
                            <el-col :span="10">
                              <el-form-item
                                label="包装单位:"
                                prop="ebFtPlan.packageTypeName"
                              >
                                <el-associate
                                  style="width: 100%"
                                  :columns="associate_columns_packageType"
                                  :query-method="
                                  associate_queryMethod_packageType
                                "
                                  class="input_length"
                                  clearable
                                  :query-length="0"
                                  :default-first-option="true"
                                  label-prop="enName"
                                  value-prop="mdChargeunitCode"
                                  placeholder=""
                                  v-model="ebFtPlanEditForm.ebFtPlan.packageTypeName"
                                  :title="ebFtPlanEditForm.ebFtPlan.packageTypeName"
                                  size="mini"
                                  case="upper"
                                  ref="ebFtPlan.packageTypeName"
                                />
                              </el-form-item>
                            </el-col>
                          </el-row>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="毛重(KGS):" prop="ebFtPlan.grossWeight">
                            <el-input
                              size="mini"
                              onkeyup="value=value.replace(/[^\d.]/g, '')"
                              v-model="ebFtPlanEditForm.ebFtPlan.grossWeight"
                              :title="ebFtPlanEditForm.ebFtPlan.grossWeight"
                              ref="ebFtPlan.grossWeight"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="6">
                          <el-form-item label="体积(CBM):" prop="ebFtPlan.cube">
                            <el-input
                              size="mini"
                              onkeyup="value=value.replace(/[^\d.]/g,'')"
                              v-model="ebFtPlanEditForm.ebFtPlan.cube"
                              :title="ebFtPlanEditForm.ebFtPlan.cube"
                              ref="ebFtPlan.cube"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col>
                      <el-row>
                        <el-col :span="9">
                          <el-form-item label="中文品名:" prop="cargoDescriptionCn">
                            <el-input
                              size="mini"
                              case="upper"
                              v-model="ebFtPlanEditForm.ebFtPlan.cargoDescriptionCn"
                              :title="ebFtPlanEditForm.ebFtPlan.cargoDescriptionCn"
                            ></el-input>
                          </el-form-item>
                        </el-col>
                        <el-col :span="15"> </el-col>
                      </el-row>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>
    <!-- 货物小计-end -->
    <!-- 箱货明细-start -->
    <el-row class="panel-top" id="box">
      <el-col>
         <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">箱货明细</span>
                </el-col>
                </div>
           </el-row>
        <el-row class="content-panel">
          <el-col>
            <el-row style="background-color:#fff;padding-bottom:10px;">
              <el-col :span="9">
                <el-button
                    type="primary"
                    size="mini"
                    @click="boxGoodsAdd"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                >新增
                </el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    @click="boxGoodsCopy"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                >复制
                </el-button
                >
                <el-button
                    type="danger"
                    size="mini"
                    @click="boxGoodsDelete"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                >删除
                </el-button
                >
                <el-button
                    type="primary"
                    size="mini"
                    @click="boxGoodsQuote"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                >引用
                </el-button
                >
                 <el-button
                    type="primary"
                    size="mini"
                    plain
                    @click="paste"
                    :loading="loading"
                   >批量粘贴
                   </el-button>
              </el-col>
              <el-col :span="10">
                      <span
                        style="
                          display: block;
                          width: 100%;
                          word-break: break-word;
                          color: red;
                          font-size: 12px;
                          margin-top:9px;
                        "
                      >箱型箱量汇总:{{ ebFtPlanEditForm.ebOrder.ctnNum }}</span
                      >
              </el-col>
            </el-row>
            <el-row class="panel-top">
              <hot-table
                  ref="boxGoodsTableRef"
                  :data-source="boxGoodsTableDataSource"
                  :settings="boxGoodsTableSettings"
                  @cellClick="boxGoodsTableCellClick"
                  @rowClick="boxGoodsTableRowClick"
                  :rules="boxGoodsTableRules"
                  :disabled="ebFtPlanEditForm.ebOrder.notEditable"
              >
                <hot-column
                    :has-tip="true"
                    data="brokerMblNo"
                    title="<label style='color:red'>*</label>提单号"
                >
                  <el-input-editor
                      :controls="true"
                      hot-editor
                      name="brokerMblNo"
                      case="upper"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="ctnNo"
                    title="<label style='color:red'>*</label>箱号"
                >
                  <el-associate-editor
                      hot-editor
                      :allow-create="true"
                      style="width: 100%"
                      :columns="associate_columns_ctnNo"
                      :query-method="associate_queryMethod_ctnNo"
                      class="input_length"
                      clearable
                      case="upper"
                      :default-first-option="true"
                      label-prop="ctnNo"
                      value-prop="ctnNo"
                      placeholder=""
                      size="small"
                      name="ctnNo"
                      @change="boxCtnNoChange"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="sealNo"
                    title="封号"
                >
                  <el-input-editor
                      case="upper"
                      :controls="true"
                      hot-editor
                      name="sealNo"
                      @change="sealNoChange"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="ctnSizeType"
                    title="箱型"
                >
                  <el-associate-editor
                      hot-editor
                      style="width: 100%"
                      :columns="associate_columns_ctnSizeType"
                      :query-method="associate_queryMethod_ctnSizeType"
                      class="input_length"
                      clearable
                      case="upper"
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="containerType"
                      value-prop="containerType"
                      placeholder=""
                      size="small"
                      name="ctnSizeType"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="cargoDescription"
                    title="品名"
                >
                  <el-input-editor
                      case="upper"
                      :controls="true"
                      hot-editor
                      name="cargoDescription"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="hsCode"
                    title="HS CODE"
                >
                  <el-input-editor
                      case="upper"
                      :controls="true"
                      hot-editor
                      name="cargoDescription"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="noOfPackage"
                    title="<label style='color:red'>*</label>件数"
                >
                  <el-input-number-editor
                      :controls="false"
                      :precision="0"
                      hot-editor
                      name="noOfPackage"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="packageTypeName"
                    title="<label style='color:red'>*</label>包装单位"
                >
                  <el-associate-editor
                      case="upper"
                      hot-editor
                      style="width: 100%"
                      :columns="associate_columns_packageType"
                      :query-method="associate_queryMethod_packageType"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="enName"
                      value-prop="enName"
                      placeholder=""
                      size="mini"
                      name="packageTypeName"
                      @change="boxPackageTypeChange"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="grossWeight"
                    title="<label style='color:red'>*</label>毛重(KGS)"
                >
                  <el-input-number-editor
                      :controls="false"
                      :precision="3"
                      hot-editor
                      :min="0"
                      name="grossWeight"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="cube"
                    title="<label style='color:red'>*</label>体积(CBM)"
                >
                  <el-input-number-editor
                      :controls="false"
                      :precision="3"
                      hot-editor
                      :min="0"
                      name="cube"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column :has-tip="true" data="marks" title="唛头">
                  <el-input-editor
                      case="upper"
                      :controls="true"
                      hot-editor
                      name="marks"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"

                  />
                </hot-column>
                <hot-column :has-tip="true" data="unNo" title="Un Code(危)">
                  <el-input-editor
                    case="upper"
                    :controls="true"
                    hot-editor
                    name="unNo"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column :has-tip="true" data="hazardClass" title="危险品类别">
                  <el-input-editor
                    case="upper"
                    :controls="true"
                    hot-editor
                    name="hazardClass"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column :has-tip="true" data="urgentContract" title="危险品联系人">
                  <el-input-editor
                    case="upper"
                    :controls="true"
                    hot-editor
                    name="urgentContract"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column :has-tip="true" data="urgentContractTel" title="危险品联系人电话">
                  <el-input-editor
                    case="upper"
                    :controls="true"
                    hot-editor
                    name="urgentContractTel"
                    :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
              </hot-table>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 箱货明细-end -->
    <!-- VGM信息-start -->
    <el-row class="panel-top" id="vgm">
      <el-col>
     <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">VGM信息</span>
                </el-col>
                </div>
         </el-row>
        <el-row class="content-panel">
          <el-col>
            <el-row style="background-color:#fff;padding-bottom:10px;">
              <el-button
                  type="primary"
                  size="mini"
                  @click="VGMAdd"
                  :disabled="ebFtPlanEditForm.ebOrder.notEditable"
              >新增
              </el-button
              >
              <el-button
                  type="primary"
                  size="mini"
                  @click="VGMCopy"
                  :disabled="ebFtPlanEditForm.ebOrder.notEditable"
              >同步VGM
              </el-button
              >
              <el-button
                  type="danger"
                  size="mini"
                  @click="VGMDelete"
                  :disabled="ebFtPlanEditForm.ebOrder.notEditable"
              >删除
              </el-button
              >
            </el-row>
            <el-row class="panel-top">
              <hot-table
                  ref="VGMTableRef"
                  :data-source="VGMTableDataSource"
                  :settings="VGMTableSettings"
                  @cellClick="VGMTableCellClick"
                  @rowClick="VGMTableRowClick"
                  :rules="VGMTableRules"
                  :disabled="ebFtPlanEditForm.ebOrder.notEditable"
              >
                <hot-column
                    :has-tip="true"
                    data="ctnNo"
                    title="<label style='color:red'>*</label>箱号"
                >
                  <el-associate-editor
                      hot-editor
                      :allow-create="true"
                      style="width: 100%"
                      :columns="associate_columns_ctnNo"
                      :query-method="associate_queryMethod_ctnNo"
                      class="input_length"
                      clearable
                      case="upper"
                      :default-first-option="true"
                      label-prop="ctnNo"
                      value-prop="ctnNo"
                      placeholder=""
                      size="small"
                      name="ctnNo"
                      @change="vgmCtnNoChange"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="sealNo"
                    title="铅封号"
                >
                  <el-input-editor
                      case="upper"
                      :controls="true"
                      hot-editor
                      name="sealNo"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="ctnSizeType"
                    title="<label style='color:red'>*</label>箱型尺寸"
                >
                  <el-associate-editor
                      hot-editor
                      style="width: 100%"
                      :columns="associate_columns_ctnSizeType"
                      :query-method="associate_queryMethod_ctnSizeType"
                      class="input_length"
                      clearable
                      :query-length="0"
                      :default-first-option="true"
                      label-prop="containerType"
                      value-prop="containerType"
                      placeholder=""
                      size="small"
                      name="ctnSizeType"
                      case="upper"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmTareWeight"
                    title="VGM箱皮重(KGS)"
                >
                  <el-input-number-editor
                      :controls="false"
                      :precision="3"
                      :min="0"
                      hot-editor
                      name="vgmTareWeight"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column :has-tip="true"
                            data="vgmWeight"
                            title="<label style='color:red'>*</label>VGM箱总重(KGS)">
                  <el-input-number-editor
                      :controls="false"
                      :precision="3"
                      :min="0"
                      hot-editor
                      name="vgmWeight"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmVerifyType"
                    title="称重方式"
                    dictName="VGM_VERIFY_TYPE"
                >
                  <el-select-editor
                      name="vgmVerifyTypeCn"
                      hot-editor
                      @change="changeVgmVerifyType"
                      clearable
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  >
                    <el-option
                        v-for="item in vgmVerifyTypeOptions"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                    >
                    </el-option>
                  </el-select-editor>
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmVerifyAddress"
                    title="称重地点"
                >
                  <el-input-editor
                      case="upper"
                      :controls="false"
                      hot-editor
                      name="vgmVerifyAddress"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmVerifyDate"
                    date-format="YYYY-MM-DD"
                    title="称重日期"
                >
                  <el-date-picker-editor
                      align="right"
                      type="date"
                      style="width: 100%"
                      name="vgmVerifyDate"
                      value-format="yyyy-MM-dd"
                      format="yyyy-MM-dd"
                      hot-editor
                      :picker-options="pickerOptions"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmShipperName"
                    title="<label style='color:red'>*</label>责任人"
                >
                  <el-input-editor
                      case="upper"
                      :controls="false"
                      hot-editor
                      name="vgmShipperName"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmVerifyPerson"
                    title="<label style='color:red'>*</label>责任人签名"
                >
                  <el-input-editor
                      case="upper"
                      :controls="false"
                      hot-editor
                      name="vgmVerifyPerson"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmContactTel"
                    title="<label style='color:red'>*</label>电话"
                >
                  <el-input-editor
                      case="upper"
                      :controls="false"
                      hot-editor
                      name="vgmContactTel"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
                <hot-column
                    :has-tip="true"
                    data="vgmContactEmail"
                    title="<label style='color:red'>*</label>联系人邮箱"
                >
                  <el-input-editor
                      case="upper"
                      :controls="false"
                      hot-editor
                      name="vgmContactEmail"
                      :disabled="ebFtPlanEditForm.ebOrder.notEditable"
                  />
                </hot-column>
              </hot-table>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- VGM信息-end -->
    <!-- 箱信息汇总-start -->
    <el-row class="panel-top">
      <el-col>
          <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">按箱汇总</span>
                   <span style="color:red;margin-left:20px;font-size:12px">保存后会按箱货信息自动汇总,无需录入!</span>
                </el-col>
                </div>
         </el-row>
        <el-row class="content-panel">
          <el-col>
            <el-row>
              <hot-table
                  ref="boxCollectTableRef"
                  :data-source="boxCollectTableDataSource"
                  :settings="boxCollectTableSettings"
                  @cellDblclick="boxCollectTableCellClick"
                  @rowDblclick="boxCollectTableRowClick"
                  :rules="boxCollectTableRules"
              >
                <!-- <hot-column :has-tip="true" data="" title="提单号"></hot-column> -->
                <hot-column
                    :has-tip="true"
                    data="ctnNo"
                    title="箱号"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="sealNo"
                    title="封号"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="ctnSizeType"
                    title="箱型"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="noOfPackage"
                    title="单箱件数"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="grossWeight"
                    title="单箱毛重(KGS)"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="cube"
                    title="单箱体积(CBM)"
                ></hot-column>
              </hot-table>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 箱信息汇总-end -->
    <!-- 提单箱信息汇总-start -->
    <el-row class="panel-top">
      <el-col>
         <el-row class="title-panel-external">
                <div class="title-panel">
                  <el-col>
                  <span class="title-text">按票汇总</span>
                   <span style="color:red;margin-left:20px;font-size:12px">保存后会按箱货信息自动汇总,无需录入!</span>
                </el-col>
                </div>
         </el-row>
        <el-row class="content-panel">
          <el-col>
            <el-row>
              <hot-table
                  ref="billCollectTableRef"
                  :data-source="billCollectTableDataSource"
                  :settings="billCollectTableSettings"
                  @cellDblclick="billCollectTableCellClick"
                  @rowDblclick="billCollectTableRowClick"
                  :rules="billCollectTableRules"
              >
                <hot-column
                    :has-tip="true"
                    data="brokerMblNo"
                    title="提单号"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="cargoDescription"
                    title="英文品名"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="marks"
                    title="唛头"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="noOfPackage"
                    title="件数"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="packageTypeName"
                    title="包装单位"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="grossWeight"
                    title="毛重(KGS)"
                ></hot-column>
                <hot-column
                    :has-tip="true"
                    data="cube"
                    title="体积(CBM)"
                ></hot-column>
              </hot-table>
            </el-row>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
    <!-- 提单箱信息汇总-end -->
  <div>



    <!-- 底部按钮 -->
    <el-row
        class="btn-container panel-top"
        type="flex"
        justify="end"
        align="middle"
    >


<el-button
                      type="primary"
                      size="mini"
                      plain
                      @click="downLoadFile"
                      :loading="loading"
                        >下载导入模板
                        </el-button>
    <el-button
              type="primary"
              size="mini"
              plain
             @click="openPrint"
              :loading="loading"
          >打印
          </el-button
          >

          <el-button
                        type="primary"
                        size="mini"
                        plain
                       @click="createMblConfirm"
                        :loading="loading"
                    >生成提单确认件
                    </el-button
                    >

      <el-button
          type="primary"
          size="mini"
          @click="validateEditFromInfo(2)"
          v-if="!ebFtPlanEditForm.ebOrder.notEditable"
          :loading="loading"
      >保存
      </el-button
      >
      <el-button
          type="primary"
          size="mini"
          @click="validateEditFromInfo(3)"
          :disabled="submitVisible"
          :loading="loading"
          v-if=false
      >提交
      </el-button
      >

       <!-- <el-button
        type="primary"
        size="mini"
        @click="changeHistoryBox"
        v-preventReClick
      >修改历史
      </el-button>
      <el-button
          size="mini"
          @click="cancelSub"
          :disabled="!submitVisible || !(ebFtPlanEditForm.ebFtPlan.approvalStatus === 'SUB')"
          :loading="loading"
          v-if="ebFtPlanEditForm.ebFtPlan.approvalStatus === 'SUB'"
      >撤销提交
      </el-button
      > -->
      <change_history_box
        :change-history-visible-flag-init="changeHistoryBoxVisible"
        :ebOrder="ebFtPlanEditForm.ebOrder"
      />
    </el-row>
  </div>

  <el-dialog
   :visible.sync="mdReportTemplateVisible"
        title="打印"
        :append-to-body="true"
        :close-on-click-modal="true"
        width="70%"
      >
        <el-row>
          <el-button class="el-button-search" type="primary" size="small" plain @click="preview()" >预览</el-button>
          <el-button class="el-button-search" type="primary" size="small" plain @click="exportExcel()" >导出</el-button>
        </el-row>
        <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
          <hot-table
            ref="mdReportTemplateTableRef"
            :data-source="mdReportTemplateData"

          >
            <hot-column :has-tip="true" data="templateNameCn" title="套版名称" width="150"></hot-column>
          </hot-table>
          <!-- 分页start -->
          <!-- 分页end -->
        </el-row>
        </el-dialog>

        <el-dialog
           :visible.sync="pasteVisible"
                title="批量粘贴"
                :append-to-body="true"
                :close-on-click-modal="true"
                width="70%"
              >
<el-row>请在您的 <label style="color:red;font-weight:bold">Excel</label> 中批量复制好信息后，粘贴至下列文本框<label style="color:red;font-weight:bold">(注：须包含表头一起复制)</label></el-row>
                <el-row style="margin-top: 15px;margin-bottom: 20px;height: 200px">
               <el-form
                    :model="pasteForm"
                    class="form-panel"
                    label-position="top"
                  >
                      <el-form-item label="" prop="markReason" >
                       <el-input
                               size="small"
                               type="textarea"
                               :rows="9"

                               v-model="pasteForm.markReason"
                               :title="pasteForm.markReason"
                                     >
                   </el-input>
                  <el-row style="text-align:center">
                        <el-button type="primary" size="small" plain @click="importPaste()" >导入</el-button>
                        <el-button  type="danger" size="small" plain @click="closePaste()" >关闭</el-button>
                   </el-row>

                                   </el-form-item>
</el-form>
                </el-row>
                </el-dialog>
     <el-dialog
               :visible.sync="downloadVisible"
                    title="下载导入模板"
                    :append-to-body="true"
                    :close-on-click-modal="true"
                    width="70%"
                  >
                   <el-row>
                            <el-button class="el-button-search" type="primary" size="small" plain @click="download()" >下载</el-button>

                          </el-row>
                          <el-row style="margin-top: 15px;margin-bottom: 20px;height: 300px">
                            <hot-table
                              ref="mdReportTemplateRef"
                              :data-source="mdReportTemplateData"

                            >
                              <hot-column :has-tip="true" data="templateNameCn" title="模版名称" width="150"></hot-column>
                            </hot-table>

                          </el-row>

                    </el-dialog>




    </div>

</template>




<script>
import { queryCountry, queryCtnSizeInfo, queryDictRows, queryPackageInfo,queryGoCtnInfo, } from "@/api/commonService";
import {changeIsActive, publicSave, publicBill, revokeSub, saveAndSub, checkForSubmit,} from "@/api/bookingRequest";
import { queryManifestHyperlinks } from '@/api/queryMainSystem'
import {
  delectEbCtnById,
  delectGoCtnById,
  deteleEbFtPlanCtnCargoById,
  manifestImport,
  manifestSummaryByBox,
  manifestSummaryByTicket,
  manifestJsonSummaryByBox,
  manifestJsonSummaryByTicket,
  queryEbCtnRelation,
  queryEditManifest,
  updateManifest,
  queryMdReportTemplate
} from "@/api/manifest";
import { boxGoodsValidate, editFromInfoValidate, VGMEbCtnValidate } from "@/rules/maniFestEditRules";
import editFromInfo from "@/views/manifest/editFromInfo";
import ebCtn from "@/api/ebCtn";
import ScrollPane from "@/layout/components/TagsView/ScrollPane";
import uploadExcel from "@/components/UploadExcel/index";
import { querySpOrderStatus } from "@/api/status";
import autoFocusMixin from "@/mixin/autoFocus"
import changeHistoryBox from "@/views/booking/ReviseHistoryBox";

export default {
  name: "manifestAdd",
  components: {
    editFromInfo,
    ScrollPane,
    uploadExcel,
    change_history_box: changeHistoryBox,
  },
  inject: ["reload"],
  mixins: [autoFocusMixin],
  watch: {
    "ebFtPlanEditForm.ebFtPlanPartySh": function () {
      let self = this;
      let data = {
        countryNameEn: self.ebFtPlanEditForm.ebFtPlanPartySh.countryName,
        mdCountryId: self.ebFtPlanEditForm.ebFtPlanPartySh.mdCountryId,
        countryCode: self.ebFtPlanEditForm.ebFtPlanPartySh.countryCode,
      }
      if (self.ebFtPlanEditForm.ebFtPlanPartySh.countryName !== undefined && self.ebFtPlanEditForm.ebFtPlanPartySh.countryName !== null && self.ebFtPlanEditForm.ebFtPlanPartySh.countryName !== "") {
        self.queryAeoCode(data, "SH");
      }
    },
    "ebFtPlanEditForm.ebFtPlanPartyNt": function () {
      let self = this;
      let data = {
        countryNameEn: self.ebFtPlanEditForm.ebFtPlanPartyNt.countryName,
        mdCountryId: self.ebFtPlanEditForm.ebFtPlanPartyNt.mdCountryId,
        countryCode: self.ebFtPlanEditForm.ebFtPlanPartyNt.countryCode,
      }
      if (self.ebFtPlanEditForm.ebFtPlanPartyNt.countryName !== undefined && self.ebFtPlanEditForm.ebFtPlanPartyNt.countryName !== null && self.ebFtPlanEditForm.ebFtPlanPartySh.countryName !== "") {
        self.queryAeoCode(data, "NT");
      }
    },
    "ebFtPlanEditForm.ebFtPlanPartyCn": function () {
      let self = this;
      let data = {
        countryNameEn: self.ebFtPlanEditForm.ebFtPlanPartyCn.countryName,
        mdCountryId: self.ebFtPlanEditForm.ebFtPlanPartyCn.mdCountryId,
        countryCode: self.ebFtPlanEditForm.ebFtPlanPartyCn.countryCode,
      }
      if (self.ebFtPlanEditForm.ebFtPlanPartyCn.countryName !== undefined && self.ebFtPlanEditForm.ebFtPlanPartyCn.countryName !== null && self.ebFtPlanEditForm.ebFtPlanPartySh.countryName !== "") {
        self.queryAeoCode(data, "CN");
      }
    },
  },
  data() {
    return {
      mdReportTemplateVisible: false,
      pasteVisible: false,
      downloadVisible: false,
      mblNo:'',
      fullPath: '',
      fullscreenLoading: false,
      type: null, //类型，从什么入口进来
      isAddManiFest: true,
      isAddManiFest1: true,
      isAddManiFest2: false,
      icon1: require("@/assets/img/status/status1.png"),
      icon2: require("@/assets/img/status/status2.png"),
      icon3: require("@/assets/img/status/status3.png"),
      icon4: require("@/assets/img/status/status4.png"),
      icon5: require("@/assets/img/status/status5.png"),
      icon6: require("@/assets/img/status/status6.png"),
      icon7: require("@/assets/img/status/status7.png"),
      icon8: require("@/assets/img/status/status8.png"),
      icon9: require("@/assets/img/status/status9.png"),
      mdReportTemplateData: [],
      axisStatusList: [
        {
          index: "0",
          text: ["舱单未发送", null],
          iconStatus: {
            "0": require("@/assets/img/status/status1.png"),
            "2": require("@/assets/img/status/status9.png"),
          },
        },
        {
          index: "0",
          text: ["舱单已发送船代", null],
          iconStatus: {
            "0": require("@/assets/img/status/status2.png"),
            "2": require("@/assets/img/status/status8.png"),
          },
        },
        {
          index: "0",
          text: ["舱单船代已接收", null],
          iconStatus: {
            "0": require("@/assets/img/status/status3.png"),
            "2": require("@/assets/img/status/status7.png"),
          },
        },
        {
          index: "0",
          text: ["船代发送舱单成功", null],
          iconStatus: {
            "0": require("@/assets/img/status/status4.png"),
            "2": require("@/assets/img/status/status6.png"),
          },
        },
        {
          index: "0",
          text: ["海关已接收舱单", null],
          iconStatus: {
            "0": require("@/assets/img/status/status5.png"),
            "2": require("@/assets/img/status/status9.png"),
          },
        },
      ],
      loading: false,
      newStatus: "NEW",
      ebFtPlan: {},
      aeoCodeSh: [],
      aeoCodeNt: [],
      aeoCodeCn: [],
      ebFtPlanParties: [],
      pasteForm:{
        markReason:''
      },
      ebFtPlanEditForm: {
        //基本信息
        //ebOrder
        ebOrder: {
          ebOrderId: null,
          mblNo: null,
          carrierId: null,
          carrierName: null,
          vesselName: null,
          vesselId: null,
          voyage: null,
          podId: null,
          podName: null,
          mblTransportTermFrom: null,
          mblTransportTermTo: null,
          mblPaymentType: null,
          rowStatus: 4,
          etd: null,
          notEditable: false,
        },
        //ebFtPlan
        ebFtPlan: {
          ebFtPlanId: null,
          approvalStatus: "NEW",
          shipAgencyId: null,
          shipAgencyName: null,
          billProperty: null,
          loadDate: null,
          placeOfDestId: null,
          placeOfDestName: null,
          manifestStatus: "NEW",
          rowStatus: 4,
          manifestFeedback: null,
          marks: null,
          cargoDescription: null,
          noOfPackage: null,
          packageTypeName: null,
          packageTypeCode: null,
          grossWeight: null,
          cube: null,
          cargoDescriptionCn: null,
        },
        //发货人信息
        ebFtPlanPartySh: {
          mdCountryId: null,
          aeoCodeType: null,
          ebFtPlanPartyId: null,
          partyMainCode: null,
          partyType: "SH",
          partyMainName: null,
          partyAddress: null,
          partyMainNameCn: null,
          countryCode: null,
          countryName: null,
          tel: null,
          postCode: null,
          fax: null,
          contactPerson: null,
          contactTel: null,
          aeoNo: null,
          rowStatus: 4,
        },
        //收货人信息
        ebFtPlanPartyCn: {
          mdCountryId: null,
          aeoCodeType: null,
          ebFtPlanPartyId: null,
          partyMainCode: null,
          partyType: "CN",
          partyMainName: null,
          partyAddress: null,
          countryCode: null,
          countryName: null,
          tel: null,
          postCode: null,
          fax: null,
          contactPerson: null,
          contactTel: null,
          aeoNo: null,
          rowStatus: 4,
          partyMainNameCn: null
        },
        //通知人信息
        ebFtPlanPartyNt: {
          mdCountryId: null,
          aeoCodeType: null,
          ebFtPlanPartyId: null,
          partyMainCode: null,
          partyType: "NT",
          partyMainName: null,
          partyAddress: null,
          countryCode: null,
          countryName: null,
          tel: null,
          postCode: null,
          fax: null,
          contactPerson: null,
          contactTel: null,
          aeoNo: null,
          rowStatus: 4,
          partyMainNameCn: null
        },
      },
      changeHistoryBoxVisible: false,
      // VGM信息
      VGMTableDataSource: [],
      herd: {
        样例: "styel",
      },
      VGMTableSelectRowIndex: null,
      VGMTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      VGMTableRules: {},
      vgmVerifyTypeOptions: [],
      VGMImportDialogVisible: false,
      // VGM结束
      cargoInfoFormRules: {
        'ebFtPlan.cargoDescription': [{
          required: true,
          message: "不能为空",
          trigger: ['blur', 'change']
        }],
        // 'ebFtPlan.marks': [{
        //   required: true,
        //   message: "不能为空",
        //   trigger: ['blur', 'change']
        // }],
        'ebFtPlan.noOfPackage': [{
          required: true,
          message: "不能为空",
          trigger: ['blur', 'change']
        }],
        'ebFtPlan.packageTypeName': [{
          required: true,
          message: "不能为空",
          trigger: ['blur', 'change']
        }],
        'ebFtPlan.grossWeight': [{
          required: true,
          message: "不能为空",
          trigger: ['blur', 'change']
        }],
        'ebFtPlan.cube': [{
          required: true,
          message: "不能为空",
          trigger: ['blur', 'change']
        }],
      },
      //箱型联想控件
      associate_columns_ctnSizeType: [
        {
          title: "箱型尺寸",
          field: "containerType",
        },
      ],
      //箱号联想控件
      associate_columns_ctnNo: [
        {
          title: "箱号",
          field: "ctnNo",
        },
      ],

      //包装联想控件
      associate_columns_packageType: [
        {
          title: "中文名称",
          field: "cnName",
        },
        {
          title: "英文名称",
          field: "enName",
        },
        {
          title: "代码",
          field: "mdChargeunitCode",
        },
      ],
      // 箱货明细信息
      boxGoodsTableDataSource: [],
      boxGoodsTableSelectRowIndex: null,
      boxGoodsTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,

      },
      boxGoodsTableRules: {},
      fullEmptyStatusOptions: [],
      // 箱货明细结束
      // 箱信息汇总
      boxCollectTableDataSource: [],
      boxCollectTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      boxCollectTableRules: {},
      // 提单箱信息汇总
      billCollectTableDataSource: [],
      billCollectTableSettings: {
        height: 200,
        autoColumnSize: true,
        stretchH: "none", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      billCollectTableRules: {},
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            },
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            },
          },
        ],
      },
      submitVisible: false,
      dataParams: {},
      completeStatus: 0,
    };
  },
  async created() {

    this.getSelectList();
    if (this.$route.query.isAddManiFest) {
      this.isAddManiFest = false;
    }
  },
  mounted() {
    this.type = this.$route.query.mainfest
        ? this.$route.query.mainfest
        : "replaceManifest";
  /*   if (this.$route.query.ebOrderId !== null) {
      const ebOrderId = this.$route.query.ebOrderId;
      this.init(ebOrderId);
    } */
      if (this.$route.fullPath.indexOf("manifestHyperlinks?") > 0) {
        console.log(this.$route.fullPath)
      self.fullscreenLoading = true;
      let s = this.$route.fullPath;
      self.fullPath = this.$route.fullPath;
      if (s !== undefined) {
        this.init(s);
      }
    }
    this.ebFtPlanEditFormRules = editFromInfoValidate();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      let self = vm;
      self.type = self.$route.query.mainfest
          ? self.$route.query.mainfest
          : "replaceManifest";
/*       if (this.$route.query.ebOrderId !== null) {
        const ebOrderId = this.$route.query.ebOrderId;
        this.init(ebOrderId);
      } */
      if (this.$route.fullPath.indexOf("manifestHyperlinks?") > 0) {
      let s = this.$route.fullPath;
      if (s !== undefined) {
        this.init(s);
      }
    }
    });
  },
  beforeDestroy() {
    let _this = this;
    // 离开页面删除检测器和所有侦听器
    _this.resizeObserver.disconnect();
  },
  methods: {
    /*
     *获取状态条
     */
    querySpOrderStatus(id) {
      let self = this;
      let data = {
        stageCode: "FT",
        goOrderId: id,
      };
      querySpOrderStatus(data)
          .then((res) => {
            if (res.success) {
              console.log(res);
              let newAxisStatusList = self.axisStatusList
              res.records.node.forEach((item, index) => {
                newAxisStatusList[index]['index'] = item['index'];
                newAxisStatusList[index]['text'] = item['text'];
              })
              self.axisStatusList = newAxisStatusList
            } else {
            }
          })
          .catch((error) => {
            console.log(error);
          });
    },
    /*
     *获取箱信息汇总
     */
    getManifestSummaryByBox(ebFtPlanId) {
      let self = this;
      if (ebFtPlanId) {
        let data = { ebFtPlanId };
        manifestSummaryByBox(data)
            .then((res) => {
              if (res.success) {
                self.boxCollectTableDataSource = res.records;
              }
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },
    getManifestJsonSummaryByBox(goOrderId) {
            let self = this;
            if (goOrderId) {
              let data = { goOrderId };
              manifestJsonSummaryByBox(data)
                  .then((res) => {
                    if (res.success) {
                      self.boxCollectTableDataSource = res.records;
                    }
                  })
                  .catch((err) => {
                    console.log(err);
                  });
            }
          },
    /*
     *获取箱信息汇总
     */
    getManifestSummaryByTicket(ebFtPlanId) {
      let self = this;
      if (ebFtPlanId) {
        let data = { ebFtPlanId };
        manifestSummaryByTicket(data)
            .then((res) => {
              if (res.success) {
                self.billCollectTableDataSource = res.records;
              }
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },
    getManifestJsonSummaryByTicket(goOrderId) {
      let self = this;
      if (goOrderId) {
        let data = { goOrderId };
        manifestJsonSummaryByTicket(data)
            .then((res) => {
              if (res.success) {
                self.billCollectTableDataSource = res.records;
              }
            })
            .catch((err) => {
              console.log(err);
            });
      }
    },
    changeHistoryBox() {
      this.changeHistoryBoxVisible = !this.changeHistoryBoxVisible;
    },
    vaildStringAsciiCodeWithRowMbl(str) {
      var strNew = ""+str;
      var strArr = strNew.split("\n");
      if (strArr.length >0) {

        var msgArr = [];
        for (var i in strArr) {
          var str = strArr[i];
          var errorStr = str.replace(/[\x22\x23]|[\x25-\x3E]|[\x40-\x5A]|[\x5C\x5F]|[\x61-\x7A]|[\x20\x0A\x0D]/g,'');
          errorStr = errorStr.replaceAll('\\','');
          errorStr = errorStr.replaceAll('℃','');
          errorStr = errorStr.replaceAll('!','');
          errorStr = errorStr.replaceAll('|','');
          errorStr = errorStr.replaceAll('[','');
          errorStr = errorStr.replaceAll(']','');
          if(errorStr.length > 0){
            msgArr.push("存在特殊字符【" + errorStr + "】");
          }
        }
        return msgArr;
      }
    },
    vaildParty(){
      let self = this;
      let hasSpec = false;
      let msgSH = "";
      if(self.ebFtPlanEditForm.ebFtPlanPartySh){
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.partyMainName){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.partyMainName)
          if(msg.length > 0){
            msgSH = msgSH + "发货人名称," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.partySysCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.partySysCode)
          if(msg.length > 0){
            msgSH = msgSH + "发货人代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.partyMainCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.partyMainCode)
          if(msg.length > 0){
            msgSH = msgSH + "发货人企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.partyAddress){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.partyAddress)
          if(msg.length > 0){
            msgSH = msgSH + "发货人地址," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.tel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.tel)
          if(msg.length > 0){
            msgSH = msgSH + "发货人电话," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.fax){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.fax)
          if(msg.length > 0){
            msgSH = msgSH + "发货人传真," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.email){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.email)
          if(msg.length > 0){
            msgSH = msgSH + "发货人邮箱," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.aeoNo){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.aeoNo)
          if(msg.length > 0){
            msgSH = msgSH + "发货人AEO企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.contactPerson){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.contactPerson)
          if(msg.length > 0){
            msgSH = msgSH + "发货人具体联系人," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartySh.contactTel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartySh.contactTel)
          if(msg.length > 0){
            msgSH = msgSH + "发货人具体联系人电话," + msg;
          }
        }
      }
      let msgCN = "";
      if(self.ebFtPlanEditForm.ebFtPlanPartyCn){
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainName)
          if(msg.length > 0){
            msgCN = msgCN + "收货人名称," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.partySysCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.partySysCode)
          if(msg.length > 0){
            msgCN = msgCN + "收货人代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyMainCode)
          if(msg.length > 0){
            msgCN = msgCN + "收货人企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyAddress){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.partyAddress)
          if(msg.length > 0){
            msgCN = msgCN + "收货人地址," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.tel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.tel)
          if(msg.length > 0){
            msgCN = msgCN + "收货人电话," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.fax){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.fax)
          if(msg.length > 0){
            msgCN = msgCN + "收货人传真," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.email){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.email)
          if(msg.length > 0){
            msgCN = msgCN + "收货人邮箱," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.aeoNo){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.aeoNo)
          if(msg.length > 0){
            msgCN = msgCN + "收货人AEO企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.contactPerson){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.contactPerson)
          if(msg.length > 0){
            msgCN = msgCN + "收货人具体联系人," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyCn.contactTel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyCn.contactTel)
          if(msg.length > 0){
            msgCN = msgCN + "收货人具体联系人电话," + msg;
          }
        }
      }
      let msgNT = "";
      if(self.ebFtPlanEditForm.ebFtPlanPartyNt){
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainName)
          if(msg.length > 0){
            msgNT = msgNT + "通知人名称," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.partySysCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.partySysCode)
          if(msg.length > 0){
            msgNT = msgNT + "通知人代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainCode){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyMainCode)
          if(msg.length > 0){
            msgNT = msgNT + "通知人企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyAddress){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.partyAddress)
          if(msg.length > 0){
            msgNT = msgNT + "通知人地址," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.tel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.tel)
          if(msg.length > 0){
            msgNT = msgNT + "通知人电话," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.fax){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.fax)
          if(msg.length > 0){
            msgNT = msgNT + "通知人传真," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.email){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.email)
          if(msg.length > 0){
            msgNT = msgNT + "通知人邮箱," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.aeoNo){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.aeoNo)
          if(msg.length > 0){
            msgNT = msgNT + "通知人AEO企业代码," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.contactPerson){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.contactPerson)
          if(msg.length > 0){
            msgNT = msgNT + "通知人具体联系人," + msg + "</br>";
          }
        }
        if(self.ebFtPlanEditForm.ebFtPlanPartyNt.contactTel){
          let msg = self.vaildStringAsciiCodeWithRowMbl(self.ebFtPlanEditForm.ebFtPlanPartyNt.contactTel)
          if(msg.length > 0){
            msgNT = msgNT + "通知人具体联系人电话," + msg;
          }
        }
      }
      if (msgSH.length > 0 || msgCN.length > 0 || msgNT.length > 0) {
        hasSpec = true;
        self.$coreMethods.message("warning", msgNT+msgSH+msgCN ,true);
        return hasSpec;
      }
      return hasSpec;
    },
    vailCtnCargo(){
      let self = this;
      let hasSpec = false;
      let ctnCargoMsg = [];
      if(self.boxGoodsTableDataSource){
        let ids = 0
        self.boxGoodsTableDataSource.forEach(item =>{
          ids++;
          let ctnNomsg = self.vaildStringAsciiCodeWithRowMbl(item.ctnNo);
          if(ctnNomsg.length > 0){
            ctnCargoMsg.push("第" + ids + "行，箱号" + ctnNomsg);
          }
          let sealNomsg = self.vaildStringAsciiCodeWithRowMbl(item.sealNo);
          if(sealNomsg.length > 0){
            ctnCargoMsg.push("第" + ids + "行，封号" + sealNomsg);
          }
          let descmsg = self.vaildStringAsciiCodeWithRowMbl(item.cargoDescription);
          if(descmsg.length > 0){
            ctnCargoMsg.push("第" + ids + "行，品名" + descmsg);
          }
          let hsCodemsg = self.vaildStringAsciiCodeWithRowMbl(item.hsCode);
          if(hsCodemsg.length > 0){
            ctnCargoMsg.push("第" + ids + "行，HS CODE" + hsCodemsg);
          }
          let marksmsg = self.vaildStringAsciiCodeWithRowMbl(item.marks);
          if(marksmsg.length > 0){
            ctnCargoMsg.push("第" + ids + "行，唛头" + marksmsg);
          }
        })
      }
      let VGMMsg = []
      if(self.VGMTableDataSource){
        let vgmIds = 0;
        self.VGMTableDataSource.forEach(item => {
          vgmIds++;
          let ctnNomsg = self.vaildStringAsciiCodeWithRowMbl(item.ctnNo);
          if(ctnNomsg.length > 0){
            VGMMsg.push("第" + vgmIds + "行，箱号" + ctnNomsg);
          }
          let sealNomsg = self.vaildStringAsciiCodeWithRowMbl(item.sealNo);
          if(sealNomsg.length > 0){
            VGMMsg.push("第" + vgmIds + "行，封号" + sealNomsg);
          }
          let vgmVerifyAddressmsg = self.vaildStringAsciiCodeWithRowMbl(item.vgmVerifyAddress);
          if(vgmVerifyAddressmsg.length > 0){
            VGMMsg.push("第" + vgmIds + "行，称重地点" + vgmVerifyAddressmsg);
          }
          let vgmShipperNamemsg = self.vaildStringAsciiCodeWithRowMbl(item.vgmShipperName);
          if(vgmShipperNamemsg.length > 0){
            VGMMsg.push("第" + vgmIds + "行，责任人" + vgmShipperNamemsg);
          }
          let vgmVerifyPersonmsg = self.vaildStringAsciiCodeWithRowMbl(item.vgmVerifyPerson);
          if(vgmVerifyPersonmsg.length > 0){
            VGMMsg.push("第" + vgmIds + "行，责任人签名" + vgmVerifyPersonmsg);
          }
        })
      }
      if(ctnCargoMsg.length > 0 || VGMMsg.length > 0){
        hasSpec = true;
        let newDatas = [];
        let ids = 1;
        let h = this.$createElement;
        if(ctnCargoMsg.length > 0){
          newDatas.push(h('p', null, ids + ".箱货明细中："));
          ids++;
          ctnCargoMsg.forEach(msg => {
            newDatas.push(h('p', null, msg));
          })
        }
        if(VGMMsg.length > 0) {
          newDatas.push(h('p', null, ids + ".VGM信息中："));
          VGMMsg.forEach(msg => {
            newDatas.push(h('p', null, msg));
          })
        }
        this.$confirm(
          '提示',
          {
            title: '提示',
            message: h('div', null, newDatas),
            showCancelButton: false,
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }
        ).then(() => {})
      }
      return hasSpec;
    },
    saveAndsubmit(submitType) {
      let self = this;
      let hasSpec = self.vaildParty();
      if(hasSpec) return;
      let vaildCtn = self.vailCtnCargo();
      if(vaildCtn) return;
      //对国家与企业代码类型进行验证
      if (self.aeoCodeSh.length !== 0 && self.aeoCodeCn.length !== 0 && self.aeoCodeNt.length !== 0) {
        if (self.ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType !== undefined && self.ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType !== null) {
          if (self.aeoCodeSh.indexOf(self.ebFtPlanEditForm.ebFtPlanPartySh.aeoCodeType) === -1) {
            self.$coreMethods.message("warning", "发货人国家与企业代码类型不匹配！");
            return;
          }
        }
        if (self.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType !== undefined && self.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType !== null) {
          if (self.aeoCodeCn.indexOf(self.ebFtPlanEditForm.ebFtPlanPartyCn.aeoCodeType) === -1) {
            self.$coreMethods.message("warning", "收货人人国家与企业代码类型不匹配！");
            return;
          }
        }
        if (self.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType !== undefined && self.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType !== null) {
          if (self.aeoCodeNt.indexOf(self.ebFtPlanEditForm.ebFtPlanPartyNt.aeoCodeType) === -1) {
            self.$coreMethods.message("warning", "通知人国家与企业代码类型不匹配！");
            return;
          }
        }
      }
      //对收发通联系人联系方式验证，三项至少填一项
      if (
          (self.ebFtPlanEditForm.ebFtPlanPartySh.fax === undefined || self.ebFtPlanEditForm.ebFtPlanPartySh.fax === null || self.ebFtPlanEditForm.ebFtPlanPartySh.fax === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartySh.email === undefined || self.ebFtPlanEditForm.ebFtPlanPartySh.email === null || self.ebFtPlanEditForm.ebFtPlanPartySh.email === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartySh.tel === undefined || self.ebFtPlanEditForm.ebFtPlanPartySh.tel === null || self.ebFtPlanEditForm.ebFtPlanPartySh.tel === "")
      ) {
        self.$coreMethods.message("warning", "发货人栏位电话/邮箱/传真至少填一项！");
        return;
      }
      if (
          (self.ebFtPlanEditForm.ebFtPlanPartyNt.fax === undefined || self.ebFtPlanEditForm.ebFtPlanPartyNt.fax === null || self.ebFtPlanEditForm.ebFtPlanPartyNt.fax === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartyNt.email === undefined || self.ebFtPlanEditForm.ebFtPlanPartyNt.email === null || self.ebFtPlanEditForm.ebFtPlanPartyNt.email === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartyNt.tel === undefined || self.ebFtPlanEditForm.ebFtPlanPartyNt.tel === null || self.ebFtPlanEditForm.ebFtPlanPartyNt.tel === "")
      ) {
        self.$coreMethods.message("warning", "通知人栏位电话/邮箱/传真至少填一项！");
        return;
      }
      if (
          (self.ebFtPlanEditForm.ebFtPlanPartyCn.fax === undefined || self.ebFtPlanEditForm.ebFtPlanPartyCn.fax === null || self.ebFtPlanEditForm.ebFtPlanPartyCn.fax === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartyCn.email === undefined || self.ebFtPlanEditForm.ebFtPlanPartyCn.email === null || self.ebFtPlanEditForm.ebFtPlanPartyCn.email === "") &&
          (self.ebFtPlanEditForm.ebFtPlanPartyCn.tel === undefined || self.ebFtPlanEditForm.ebFtPlanPartyCn.tel === null || self.ebFtPlanEditForm.ebFtPlanPartyCn.tel === "")
      ) {
        self.$coreMethods.message("warning", "收货人栏位电话/邮箱/传真至少填一项！");
        return;
      }
      //判断HS CODE的类型，只能是数字，否则不能保存
      let hsCodeType = 1;//定义一个参数来标记hsCode的类型；1：为数字 ； 0：为其它
      let mblNoAndCtnNo = [];
      let reg = /^[0-9]*$/;
      self.boxGoodsTableDataSource.forEach(res => {
        //将提单号和箱号进行拼接，加入list中
        mblNoAndCtnNo.push(res.brokerMblNo + res.ctnNo);
        if (!reg.test(res.hsCode)) hsCodeType = 0;
      });
       if (hsCodeType === 0) {
        self.$coreMethods.message("warning", "HS CODE必须为数字！");
        return;
      }
      //将list转换成set对比长度，判断同一提单号下是否存在相同的箱号
     /* if (new Set(mblNoAndCtnNo).size !== mblNoAndCtnNo.length) {
        self.$coreMethods.message("warning", "同一提单号下不能有重复的箱号！");
        return;
      }*/
      //判断实装箱汇总的箱型箱量和预配箱数据是否一致
      let boxs1 = [];
      if(self.ebFtPlanEditForm.ebOrder.ctnNum !== ""
        && self.ebFtPlanEditForm.ebOrder.ctnNum !== null
        && self.ebFtPlanEditForm.ebOrder.ctnNum !== undefined ){
        boxs1= self.ebFtPlanEditForm.ebOrder.ctnNum.split("+");
      }
      //箱货明细数据
      let boxs2 = [];
      self.boxGoodsTableDataSource.forEach(item=>{boxs2.push(item)});
      let result = false;
      let ctnSizeTypeArray = [];
      let ctnNumAll = 0;
      //取出所有汇总箱型
      for (let i = 0; i < boxs1.length; i++) {
        let arr = boxs1[i].split("*")
        let ctnSizeType = arr[1];
        ctnSizeTypeArray.push(ctnSizeType);
      }
      if(boxs1.length>0 ){
        //统计每种箱型的数量
        for (let i = 0; i < boxs1.length; i++) {
          let arr = boxs1[i].split("*")
          let ctnSizeType = arr[1];
          let ctnNum = Number(arr[0]);
          if (boxs2.length > 0) {
            for (let j = 0; j < boxs2.length; j++) {
              if (boxs2.length > 1) {
                for (let k = j+1; k < boxs2.length; k++) {
                  if (!(ctnSizeTypeArray.includes(boxs2[j]) || ctnSizeTypeArray.includes(boxs2[k]))){
                    if (boxs2[j].ctnSizeType === ctnSizeType) {
                      if (boxs2[j].ctnNo === boxs2[k].ctnNo && boxs2[j].sealNo === boxs2[k].sealNo && boxs2[j].ctnSizeType === boxs2[k].ctnSizeType) {
                        boxs2.splice(k, 1, ctnSizeType)
                      }
                    }
                }
                }
              } else if (boxs2[0].ctnSizeType === ctnSizeType) {
                boxs2.splice(0,1,ctnSizeType)
              }
            }
          }
          ctnNumAll = ctnNumAll + ctnNum;
        }
        let otherNum = 0;

          let indexNum = [];
          if (boxs2.length > 0) {
            for (let g = 0; g < boxs2.length; g++) {
              if (boxs2.length > 1) {
                if (ctnSizeTypeArray.includes(boxs2[g])) {
                    indexNum.push(g);
                }
              } else if (ctnSizeTypeArray.includes(boxs2[0].ctnSizeType)) {
                otherNum--;
              } else if (!ctnSizeTypeArray.includes(boxs2[0])){
                otherNum++;
              }
            }
            if (indexNum.length > 0) {
              for (let z = indexNum.length-1; z >= 0; z--) {
                  boxs2.splice(indexNum[z],1)
              }
            }
          }
        //判断所有同一箱型数量是否符合汇总箱型总数量
        if (boxs2.length > ctnNumAll) {
          result = true;
        }
        if (otherNum > 0) {
          result = true;
        }
        //去除符合汇总箱型的数据
        if (boxs2.length > 0) {
          for (let o =  boxs2.length-1; o >= 0; o--) {
              if (ctnSizeTypeArray.includes(boxs2[o].ctnSizeType)) {
                boxs2.splice(o, 1);
              } else if (ctnSizeTypeArray.includes(boxs2[o])) {
                boxs2.splice(o, 1);
              }
          }
        }

        if (boxs2.length > 0) {
          result = true;
        }

      }else{
        if(self.ebFtPlanEditForm.ebOrder.ebOrderId !==undefined && self.ebFtPlanEditForm.ebOrder.ebOrderId !==null){
          if(boxs2.length>0){
            result = true;
          }
        }else{
          //如果是舱单代发，需要新增预配箱信息
          let ctnSizeTypes = new Set([]);
          self.ebFtPlanEditForm.ebOrder.ebCtnRequests = [];
          self.boxGoodsTableDataSource.forEach( item => {
            ctnSizeTypes.add(item.ctnSizeType);
          });
          ctnSizeTypes.forEach(ctnSizeType => {
            let objebCtnRequest={
              ctnSizeType: ctnSizeType,
              ctnQuantity: 0,
              rowStatus: 4, // 新增行状态值为4，修改行状态值为16
              isDeleted: 0,
              fclLclFlag: "FCL",
              isNor: 0,
              isSoc: 0,
            };
            self.ebFtPlanEditForm.ebOrder.ebCtnRequests.push(objebCtnRequest);
          });
          self.boxGoodsTableDataSource.forEach( item => {
            self.ebFtPlanEditForm.ebOrder.ebCtnRequests.forEach( ebCtnRequest => {
              if(item.ctnSizeType === ebCtnRequest.ctnSizeType){
                ebCtnRequest.ctnQuantity +=1;
              }
            });
          });
        }
      }
      if(result){
        self.$coreMethods.message("warning", "实装箱汇总的箱型箱量需要小于或等于预配箱数据！");
        return;
      }
      let ctnNoResult = "";
      let ctnNoSet = new Set();
      self.boxGoodsTableDataSource.forEach(item => {
        ctnNoSet.add(item.ctnNo);
      });
      ctnNoSet.forEach(item => {
        if(item){
          ctnNoResult = self.validContainerNo(item,ctnNoResult);
        }else {
          this.$coreMethods.message( "warning","箱号不能为空！");
          self.submitVisible = false;
          self.loading = false;
          return;
        }
      });
      self.$refs.VGMTableRef.hotInstance.validateColumns(
          [1, 2,3, 5, 9, 10, 11 ,12],
          (VGMTableValid) => {
            self.$refs.boxGoodsTableRef.hotInstance.validateColumns(
                [1, 2,  4, 6, 7, 8, 9, 10, 12, 13],
                (boxGoodsTableValid) => {
                  if (VGMTableValid && boxGoodsTableValid) {
                    self.loading = true;
                    let data = {
                      ebFtPlanPartySh: self.ebFtPlanEditForm.ebFtPlanPartySh,
                      ebFtPlanPartyCn: self.ebFtPlanEditForm.ebFtPlanPartyCn,
                      ebFtPlanPartyNt: self.ebFtPlanEditForm.ebFtPlanPartyNt,
                      ebOrderDTO: self.ebFtPlanEditForm.ebOrder,
                      ebFtPlan: self.ebFtPlanEditForm.ebFtPlan,
                      type: "web"
                    };
                    if(self.boxGoodsTableDataSource && self.VGMTableDataSource){
                      self.boxGoodsTableDataSource.forEach(x => {
                        let isNewCtn = true;
                        self.VGMTableDataSource.forEach(item => {
                          if(x.ctnNo === item.ctnNo){
                            isNewCtn = false;
                          }
                        })
                        if(isNewCtn){
                          let newVGM = {
                            ebCtnId: null,
                            brokerMblNo: self.ebFtPlanEditForm.ebOrder.mblNo,
                            ctnNo: x.ctnNo,
                            sealNo: x.sealNo,
                            ctnSizeType: x.ctnSizeType,
                            vgmTareWeight: null,
                            vgmWeight: null,
                            vgmVerifyType: null,
                            vgmVerifyTypeCn: null,
                            vgmVerifyAddress: null,
                            vgmVerifyDate: null,
                            vgmShipperName: null,
                            vgmVerifyPerson: null,
                            vgmContactTel: null,
                            vgmContactEmail: null,
                            vgmResponsiblePersonSign: null,
                            vgmVerifyCompanyContactTel: null,
                            vgmVerifyCompanyContactEmail: null,
                            rowStatus: 4,
                          };

                          self.VGMTableDataSource.push(newVGM);
                        }
                      })
                    }
                    data.ebFtPlan.ebFtPlanCtnCargos = self.boxGoodsTableDataSource;
                    data.ebOrderDTO.ebCtns = self.VGMTableDataSource;
                    data.dataType = "FT";
                    data.ebFtPlanPartySh.partyType = "SH"
                    data.ebFtPlanPartyNt.partyType = "NT"
                    data.ebFtPlanPartyCn.partyType = "CN"
                    data.ebFtPlan.ebFtPlanPartys = [
                      data.ebFtPlanPartySh,
                      data.ebFtPlanPartyNt,
                      data.ebFtPlanPartyCn,
                    ];
                    delete data.ebFtPlanPartySh;
                    delete data.ebFtPlanPartyNt;
                    delete data.ebFtPlanPartyCn;

                    if (data.ebOrderDTO.ebOrderId !== null &&
                        data.ebOrderDTO.ebOrderId !== undefined &&
                        data.ebOrderDTO.ebOrderId !== "") {
                      data.ebOrderDTO.rowStatus = 16;
                    } else {
                      data.ebOrderDTO.rowStatus = 4;
                    }
                    if (data.ebFtPlan.ebFtPlanId !== null &&
                        data.ebFtPlan.ebFtPlanId !== undefined &&
                        data.ebFtPlan.ebFtPlanId !== "") {
                      data.ebFtPlan.rowStatus = 16;
                    } else {
                      data.ebFtPlan.rowStatus = 4;
                    }

                    data.ebFtPlan.ebFtPlanPartys.forEach(item => {
                      if (item.ebFtPlanPartyId !== null &&
                          item.ebFtPlanPartyId !== undefined &&
                          item.ebFtPlanPartyId !== "") {
                        item.rowStatus = 16;
                      } else {
                        item.rowStatus = 4;
                      }
                      item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                      item.settleOffice = data.ebOrderDTO.settleOffice;
                    });
                    if (data.ebOrderDTO.ebOrderId){
                      if (data.ebOrderDTO.ebCtns !== null && data.ebOrderDTO.ebCtns !== undefined) {
                        data.ebOrderDTO.ebCtns.forEach(item => {
                        if(item.vgmVerifyDate){
                           let a = new Date(item.vgmVerifyDate).getHours();
                           if (a === 8) {
                              item.vgmVerifyDate = new Date(new Date(item.vgmVerifyDate).getTime() - 8 * 3600 * 1000);
                          }
                        }
                          if (item.ebCtnId !== null &&
                            item.ebCtnId !== undefined &&
                            item.ebCtnId !== "") {
                            item.rowStatus = 16;
                          } else {
                            item.rowStatus = 4;
                          }
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ctnCtnCargoVOs !== null && data.ctnCtnCargoVOs !== undefined) {
                        data.ctnCtnCargoVOs.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ebOrderDTO.ebCargos !== null && data.ebOrderDTO.ebCargos !== undefined) {
                        data.ebOrderDTO.ebCargos.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ebOrderDTO.ebCtnRequests !== null && data.ebOrderDTO.ebCtnRequests !== undefined) {
                        data.ebOrderDTO.ebCtnRequests.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ebOrderDTO.ebServiceItems !== null && data.ebOrderDTO.ebServiceItems !== undefined) {
                        data.ebOrderDTO.ebServiceItems.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ebOrderDTO.ebPartys !== null && data.ebOrderDTO.ebPartys !== undefined) {
                        data.ebOrderDTO.ebPartys.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                      if (data.ebOrderDTO.ebFtPlan.ebFtPlanPartys !== null && data.ebOrderDTO.ebFtPlan.ebFtPlanPartys !== undefined) {
                        data.ebOrderDTO.ebFtPlan.ebFtPlanPartys.forEach(item => {
                          item.settleOfficeName = data.ebOrderDTO.settleOfficeName;
                          item.settleOffice = data.ebOrderDTO.settleOffice;
                        });
                      }
                    }

                    //新增ebOrder和ebOrder.ebFtPlan
                    if (self.type === "replaceManifest") {
                      //data.ebOrder.rowStatus = 4;
                      data.ebFtPlan.rowStatus = 4;
                      data.ebOrderDTO.vgmStatus = "UNSENT";
                      data.ebOrderDTO.vgmApprovalStatus = "NEW";
                      data.ebOrderDTO.orderStatus = "NEW";
                      data.ebOrderDTO.isCancelApply = 0;
                      data.ebOrderDTO.orderType = "F";
                      data.ebOrderDTO.inputMethond = "M";
                      data.ebOrderDTO.ebOrderStatus = "BKCONFIRM";
                      data.ebOrderDTO.bizBigTypeCode = "MFE";
                      data.ebOrderDTO.bizBigTypeName = "海运集装箱出口";
                    }
                    if(ctnNoResult !== "") {
                      self.$confirm("箱号" + ctnNoResult + "不符合箱号规范，是否继续保存！", '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning'
                      }).then(() => {
                        if (submitType === 1) {
                          self.loading = false;
                        } else if (submitType === 2) {
                          publicBill(data).then((res) => {
                            if (res.success) {
                              let eiOrderId = new URLSearchParams()
                              eiOrderId.append('eiOrderId', res.records.eiOrderId)
                              changeIsActive(eiOrderId).then(res => {
                                if (res.success) {
                                  self.$coreMethods.message("success", "操作成功");
                                }
                              })
                              data.ebOrderDTO.ebFtPlan = null;
                              self.$coreMethods.message("success", "操作成功");
                              self.dataParams = res.records;
                              self.isAddManiFest = true;
                              self.type = "updateManifest";
                              self.loading = false;
                              self.completeStatus = 1;
                              self.VGMTableRules = {};
                              let s = this.$route.fullPath;
                              self.init(s)
                              self.ebFtPlanEditForm.ebOrder.notEditable = false;
                            }
                          }).catch((res) => {
                            self.loading = false;
                            self.$coreMethods.message("error", "操作失败");
                          });
                        } else if (submitType === 3) {
                          let checkManifestStatus = false;

                          var info={
                            goOrderId:data.ebOrderDTO.goOrderId
                          }
                          checkForSubmit(info).then(res => {
                            if(res.success){
                              checkManifestStatus = res.records;
                              if(checkManifestStatus){
                                self.$coreMethods.message('warning', '该订单的舱单已发送，不允许提交')
                                self.loading = false;
                                self.submitVisible = false;
                                return;
                              }else {
                                publicBill(data).then((res) => {
                                  if (res.success) {
                                    data.ebOrderDTO.ebFtPlan = null;
                                    self.$coreMethods.message("success", "操作成功");
                                    self.dataParams = res.records;
                                    self.isAddManiFest = true;
                                    self.type = "updateManifest";
                                    self.loading = false;
                                    self.completeStatus = 1;
                                    self.VGMTableRules = {};
                                    /* self.init(res.records.ebOrderId) */
                                    let s = this.$route.fullPath;
                                    self.init(s)
                                    self.ebFtPlanEditForm.ebOrder.notEditable = true;
                                  }
                                }).catch((res) => {
                                  self.loading = false;
                                  self.$coreMethods.message("error", "操作失败");
                                });
                              }
                            }
                          });
                          /*     self.submitVisible = true;
                              data.type = "web";
                              data.ebOrderDTO.status = "NEW";
                              data.ebOrderDTO.urgentLevel = "N";
                              let userInfo = JSON.parse(localStorage.getItem("userInfo"));
                              data.ebOrderDTO.submitPersonId = userInfo.userId;
                              data.ebOrderDTO.submitPerson = userInfo.userNameCn;
                              data.ebFtPlan.manifestStatus = 'NST'
                              if (data.ebOrderDTO.ebOrderStatus !== "BKCONFIRM") {
                                self.$coreMethods.message('warning', '订单没有订舱成功,无法提交')
                                self.loading = false;
                                self.submitVisible = false;
                                return;
                              } */
                          /*                       publicBill(data).then((res) => {
                                                if (res.success) {
                                                    self.$coreMethods.message("success", "操作成功");
                                                    self.$store.dispatch("tagsView/delView", self.$route).then(() => {
                                                      self.$nextTick(() => {
                                                        self.$router.push({
                                                          name: "manifestManagement",
                                                          params: {
                                                            fromWhere: "afterSubmit"
                                                          }
                                                        });
                                                      });
                                                    });
                                                    data.ebOrder.ebOrderId = self.ebOrderId = res.records.ebOrderId;
                                                    self.loading = false;
                                                    self.completeStatus = 2;
                                                }
                                              }).catch((res) => {
                                                  self.loading = false;
                                                  self.submitVisible = false;
                                              }); */
                        }
                      }).catch(() => {
                        self.submitVisible = false;
                        self.loading = false;
                      })
                    }else{
                      // 数据校验
                      if (submitType === 1) {
                        self.loading = false;
                      } else if (submitType === 2) {
                        /* data.type = "web"; */
                        //暂存草稿
  /*                       publicSave(data).then((res) => {
                          if (res.success) {
                            data.ebOrderDTO.ebFtPlan = null;
                            self.$coreMethods.message("success", "操作成功");
                            self.dataParams = res.records;
                            self.isAddManiFest = true;
                            self.type = "updateManifest";
                            self.loading = false;
                            self.completeStatus = 1;
                            self.VGMTableRules = {};
                            self.init(res.records.ebOrderId)
                          }
                        }).catch((res) => {
                          self.loading = false;
                          self.$coreMethods.message("error", "操作失败");
                        }); */
                         publicBill(data).then((res) => {
                          if (res.success) {
                            let eiOrderId = new URLSearchParams()
                            eiOrderId.append('eiOrderId', res.records.eiOrderId)
                            changeIsActive(eiOrderId).then(res => {
                              if (res.success) {
                                self.ebOrder.notEditable = false;
                                self.$coreMethods.message("success", "操作成功");
                              }
                            })
                            data.ebOrderDTO.ebFtPlan = null;
                            self.$coreMethods.message("success", "操作成功");
                            self.dataParams = res.records;
                            self.isAddManiFest = true;
                            self.type = "updateManifest";
                            self.loading = false;
                            self.completeStatus = 1;
                            self.VGMTableRules = {};
                            let s = this.$route.fullPath;
                            self.init(s)
                          }
                        }).catch((res) => {
                          self.loading = false;
                          self.$coreMethods.message("error", "操作失败");
                        });
                      } else if (submitType === 3) {
                        let checkManifestStatus = false;
                         var info={
                              goOrderId:data.ebOrderDTO.goOrderId
                                                  }
                        checkForSubmit(info).then(res => {
                          if(res.success){
                            checkManifestStatus = res.records;
                            if(checkManifestStatus){
                              self.$coreMethods.message('warning', '该订单的舱单已发送，不允许提交')
                              self.loading = false;
                              self.submitVisible = false;
                              return;
                            }else {
                              publicBill(data).then((res) => {
                                if (res.success) {
                                  data.ebOrderDTO.ebFtPlan = null;
                                  self.$coreMethods.message("success", "操作成功");
                                  self.dataParams = res.records;
                                  self.isAddManiFest = true;
                                  self.type = "updateManifest";
                                  self.loading = false;
                                  self.completeStatus = 1;
                                  self.VGMTableRules = {};
                                  /* self.init(res.records.ebOrderId) */
                                  let s = this.$route.fullPath;
                                  self.init(s)
                                }
                              }).catch((res) => {
                                self.loading = false;
                                self.$coreMethods.message("error", "操作失败");
                              });
                            }
                          }
                        });
                    /*     self.submitVisible = true;
                        data.type = "web";
                        data.ebOrderDTO.status = "NEW";
                        data.ebOrderDTO.urgentLevel = "N";
                        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
                        data.ebOrderDTO.submitPersonId = userInfo.userId;
                        data.ebOrderDTO.submitPerson = userInfo.userNameCn;
                        data.ebFtPlan.manifestStatus = 'NST'
                        if (data.ebOrderDTO.ebOrderStatus !== "BKCONFIRM") {
                          self.$coreMethods.message('warning', '订单没有订舱成功,无法提交')
                          self.loading = false;
                          self.submitVisible = false;
                          return;
                        } */
  /*                       publicBill(data).then((res) => {
                        if (res.success) {
                            self.$coreMethods.message("success", "操作成功");
                            self.$store.dispatch("tagsView/delView", self.$route).then(() => {
                              self.$nextTick(() => {
                                self.$router.push({
                                  name: "manifestManagement",
                                  params: {
                                    fromWhere: "afterSubmit"
                                  }
                                });
                              });
                            });
                            data.ebOrder.ebOrderId = self.ebOrderId = res.records.ebOrderId;
                            self.loading = false;
                            self.completeStatus = 2;
                        }
                      }).catch((res) => {
                          self.loading = false;
                          self.submitVisible = false;
                      }); */
                      }
                    }
                  } else {
                    self.loading = false;
                    self.submitVisible = false;
                    if(!boxGoodsTableValid){
                    	document.getElementById("box").scrollIntoView()
                      self.$coreMethods.message("warning", "箱货明细中有必填信息未填写！");
                    }else if(!VGMTableValid){
                      document.getElementById("vgm").scrollIntoView()
                      self.$coreMethods.message("warning", "VGM信息中有必填信息未填写！");
                    }

                  }
                }
            );
          }
      );
    },
    validContainerNo(containerNo, containerNos){
      if(containerNo.length == 11){
        var ctnArr = [];
        var strArr = ["10010203040506070809", "09020406081001030507", "07040801050902061003", "03080502100704010906"];
        for (var i=0; i < 4; i++) {
          if (containerNo.charAt(i).charCodeAt() > "Z".charCodeAt() || containerNo.charAt(i).charCodeAt() < "A".charCodeAt()) {
            containerNos += containerNo + ",";
            return containerNos;
          }
          var tempIndex = ((((parseFloat(containerNo.charAt(i).charCodeAt()) - parseFloat("A".charCodeAt())) % 10 ) + 1 ) * 2 ) - 2;
          ctnArr[i] = strArr[i].substring(tempIndex, tempIndex + 2);
        }
        for (var i=4; i < 11; i++) {
          if (containerNo.charAt(i).charCodeAt() > "9".charCodeAt() || containerNo.charAt(i).charCodeAt() < "0".charAt()) {
            containerNos+=containerNo+",";
            return containerNos;
          }
        }
        var r1 = (parseFloat(ctnArr[0]) + parseFloat(ctnArr[1]) + parseFloat(ctnArr[2]) + parseFloat(ctnArr[3])) % 11;
        var r2 = (5 * parseFloat(containerNo.charAt(4)) + 10 * parseFloat(containerNo.charAt(5))
          + 9 * parseFloat(containerNo.charAt(6)) + 7 * parseFloat(containerNo.charAt(7))
          + 3 * parseFloat(containerNo.charAt(8)) + 6 * parseFloat(containerNo.charAt(9))) % 11;
        var r3 = parseFloat((r1 + r2) % 11);
        if(r3 == 10) {
          r3 = 0;
        }
        if(r3 != parseFloat(containerNo.charAt(10))) {
          containerNos+=containerNo+",";
        }
      }else{
        containerNos+=containerNo+",";
      }
      return containerNos;
    },
    cancelSub() {
      let self = this;
      const ebOrderObj = self.processingDate();
      self.loading = true;
      var data = {
        ebOrderIds: [ebOrderObj.ebOrder.ebOrderId],
        dataType: "FT"
      };
      revokeSub(data)
          .then((res) => {
            if (res.success || res.records === 2000) {
              self.$coreMethods.message("success", "撤销提交成功");
              this.completeStatus = 1;
              let s = this.$route.fullPath;
               self.init(s)
              /* self.init(ebOrderObj.ebOrder.ebOrderId); */
              this.submitVisible = false;
            } else {
              self.$coreMethods.message("error", "撤销提交失败");
            }
            self.loading = false;
          })
          .catch((err) => {
            console.log(err);
            self.loading = false;
          });
    },
    queryEditManifest(ebOrderId) {
      let self = this;
      //发货人信息
      var ebFtPlanPartySh = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "SH",
        partyMainName: null,
        partyAddress: null,
        partyMainNameCn: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      //收货人信息
      var ebFtPlanPartyCn = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "CN",
        partyMainName: null,
        partyAddress: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      //通知人信息
      var ebFtPlanPartyNt = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "NT",
        partyMainName: null,
        partyAddress: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      let data = { ebOrderId };
      queryEditManifest(data).then((res) => {
        if (res.success) {
          let data = res.records;
          if (
              data.ebFtPlan.ebFtPlanPartys &&
              data.ebFtPlan.ebFtPlanPartys.length > 0
          ) {
            data.ebFtPlan.ebFtPlanPartys.forEach((item) => {
              if (item.partyType === "SH") ebFtPlanPartySh = item;
              if (item.partyType === "CN") ebFtPlanPartyCn = item;
              if (item.partyType === "NT") ebFtPlanPartyNt = item;
            });
          }
          self.ebFtPlanEditForm.ebFtPlan = data.ebFtPlan;
          self.VGMTableDataSource = data.ebCtns;
          self.boxGoodsTableDataSource = data.ebFtPlan.ebFtPlanCtnCargos;
          self.boxGoodsTableDataSource.forEach(function (ebFtPlanCtnCargo) {
            data.ebCtns.forEach(function (ebCtn) {
              if (ebFtPlanCtnCargo.ebCtnId === ebCtn.ebCtnId) {
                ebFtPlanCtnCargo.ctnNo = ebCtn.ctnNo;
                ebFtPlanCtnCargo.sealNo = ebCtn.sealNo;
                ebFtPlanCtnCargo.ctnSizeType = ebCtn.ctnSizeType;
                ebFtPlanCtnCargo.fullEmptyStatus = ebCtn.fullEmptyStatus;
              }
            });
          });
          const ebFtPlanEditForm = {
            ebFtPlan: data.ebFtPlan,
            ebOrder: data,
            ebFtPlanPartySh: ebFtPlanPartySh,
            ebFtPlanPartyCn: ebFtPlanPartyCn,
            ebFtPlanPartyNt: ebFtPlanPartyNt,
          };
          self.ebFtPlanEditForm = ebFtPlanEditForm;

          self.ebFtPlanEditForm.ebOrder.rowStatus = 16;
          self.ebFtPlanEditForm.ebFtPlan.rowStatus = 16;
          self.ebFtPlanEditForm.ebOrder.ebCtns.forEach(
              (item) => (item.rowStatus = 16)
          );
          self.ebFtPlanEditForm.ebFtPlan.ebFtPlanCtnCargos.forEach(
              (item) => (item.rowStatus = 16)
          );
          self.ebFtPlanEditForm.ebFtPlan.ebFtPlanPartys.forEach(
              (item) => (item.rowStatus = 16)
          );
          self.ebFtPlanEditForm.ebOrder.ebFtPlan.rowStatus = 16;
          self.ebFtPlanEditForm.ebOrder.ebFtPlan.ebFtPlanPartys.forEach(
              (item) => (item.rowStatus = 16)
          );
          //self.getManifestSummaryByBox(
              //self.ebFtPlanEditForm
         //     self.ebFtPlanEditForm.ebFtPlan.ebFtPlanId
       //   );
          self.getManifestJsonSummaryByBox(
                this.goOrderId
           );

         // self.getManifestSummaryByTicket(
         //     self.ebFtPlanEditForm.ebFtPlan.ebFtPlanId
        //  );
          self.getManifestJsonSummaryByTicket(
                                  this.goOrderId
          );
        }
      });
    },
    /* queryManifestHyperlinks(){}, */
    init(ebOrderId) {
      let self = this;
      if(ebOrderId){
        self.isAddManiFest1 = false;
      }else{
        self.isAddManiFest1 = true;
      }
      //发货人信息
      let ebFtPlanPartySh = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "SH",
        partyMainName: null,
        partyAddress: null,
        partyMainNameCn: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      //收货人信息
      let ebFtPlanPartyCn = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "CN",
        partyMainName: null,
        partyAddress: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      //通知人信息
      let ebFtPlanPartyNt = {
        aeoCodeType: null,
        ebFtPlanPartyId: null,
        partyMainCode: null,
        partyType: "NT",
        partyMainName: null,
        partyAddress: null,
        countryCode: null,
        countryName: null,
        tel: null,
        postCode: null,
        fax: null,
        contactPerson: null,
        contactTel: null,
        aeoNo: null,
        rowStatus: 4,
      };
      // if (ebOrderId) self.querySpOrderStatus(ebOrderId);
      if (ebOrderId) {
        //舱单编辑
        let query = { goOrderId: ebOrderId };
        queryManifestHyperlinks(query).then((res) => {
          if (res.success) {
            this.mblNo=res.records.mblNo;
            self.fullscreenLoading = false;
            let data = res.records;
            self.ebFtPlanEditForm.ebOrder = data;
            self.ebFtPlanEditForm.ebOrder.notEditable=false;
            if(!self.ebFtPlanEditForm.ebOrder.shipAgencyName && data.mfOrder){
              self.ebFtPlanEditForm.ebOrder.shipAgencyName = data.mfOrder.shipAgencyName
            }
            if(!self.ebFtPlanEditForm.ebOrder.customsVesselName && data.mfOrder){
              self.ebFtPlanEditForm.ebOrder.customsVesselName = data.mfOrder.customsVesselName
            }
             if(!self.ebFtPlanEditForm.ebOrder.customsVoyage && data.mfOrder){
              self.ebFtPlanEditForm.ebOrder.customsVoyage = data.mfOrder.customsVoyage
            }

            this.goOrderId=data.goOrderId;
            self.ebFtPlanEditForm.ebOrder.rowStatus = 16;
            if(self.ebFtPlanEditForm.ebOrder.ebCtns){
              self.ebFtPlanEditForm.ebOrder.ebCtns.forEach(
                  (item) => (item.rowStatus = 16)
              );
            }
            self.ebFtPlanEditForm.ebOrder.ebFtPlan.rowStatus = 16;
              if(self.ebFtPlanEditForm.ebOrder.ebFtPlan && self.ebFtPlanEditForm.ebOrder.ebFtPlan.ebFtPlanPartys){
              self.ebFtPlanEditForm.ebOrder.ebFtPlan.ebFtPlanPartys.forEach(
                  (item) => (item.rowStatus = 16)
              );
            }
            self.VGMTableDataSource = data.ebCtns || [];
            /* if (data.ebFtPlan.ebFtPlanId) { */
            if (data.ebFtPlan) {
              if (data.ebFtPlan.ebFtPlanPartys && data.ebFtPlan.ebFtPlanPartys.length > 0) {
                data.ebFtPlan.ebFtPlanPartys.forEach((item) => {
                  if (item.partyType === "SH") ebFtPlanPartySh = item;
                  if (item.partyType === "CN") ebFtPlanPartyCn = item;
                  if (item.partyType === "NT") ebFtPlanPartyNt = item;
                });
              }
              self.ebFtPlanEditForm.ebFtPlanPartySh = ebFtPlanPartySh;
              self.ebFtPlanEditForm.ebFtPlanPartyCn = ebFtPlanPartyCn;
              self.ebFtPlanEditForm.ebFtPlanPartyNt = ebFtPlanPartyNt;
              self.ebFtPlanEditForm.ebFtPlan = data.ebFtPlan;

              self.boxGoodsTableDataSource = data.ebFtPlan.ebFtPlanCtnCargos || [];

              self.boxGoodsTableDataSource.forEach(function (ebFtPlanCtnCargo) {
                data.ebCtns.forEach(function (ebCtn) {
                  if (ebFtPlanCtnCargo.ebCtnId === ebCtn.ebCtnId) {
                    ebFtPlanCtnCargo.ctnNo = ebCtn.ctnNo;
                    ebFtPlanCtnCargo.sealNo = ebCtn.sealNo;
                    ebFtPlanCtnCargo.ctnSizeType = ebCtn.ctnSizeType;
                    ebFtPlanCtnCargo.fclLclFlag = res.records.ebCtnRequests.fclLclFlag;
                    //ebFtPlanCtnCargo.fullEmptyStatus = ebCtn.fullEmptyStatus;
                  }
                });
                data.ebCtnRequests.forEach(function (ebCtnRequest) {
                  if (ebFtPlanCtnCargo.custId === ebCtnRequest.custId) {
                    ebFtPlanCtnCargo.fclLclFlag = ebCtnRequest.fclLclFlag;
                  }
                });
              });
              if (
                self.ebFtPlanEditForm.ebOrder.ebCargos !== null &&
                self.ebFtPlanEditForm.ebOrder.ebCargos !== undefined &&
                self.ebFtPlanEditForm.ebOrder.ebCargos.length > 0
              ) {
                let target = self.ebFtPlanEditForm.ebOrder.ebCargos.find((item) => {
                  return item.totalFlag === "M";
                });
                self.ebFtPlanEditForm.ebFtPlan.marks = self.ebFtPlanEditForm.ebFtPlan.marks !== ""? self.ebFtPlanEditForm.ebFtPlan.marks : target.marks;
                self.ebFtPlanEditForm.ebFtPlan.cargoDescription = self.ebFtPlanEditForm.ebFtPlan.cargoDescription !== ""? self.ebFtPlanEditForm.ebFtPlan.cargoDescription : target.cargoDescription;
                self.ebFtPlanEditForm.ebFtPlan.noOfPackage = self.ebFtPlanEditForm.ebFtPlan.noOfPackage !== 0? self.ebFtPlanEditForm.ebFtPlan.noOfPackage : target.noOfPackage;
                self.ebFtPlanEditForm.ebFtPlan.packageTypeName = self.ebFtPlanEditForm.ebFtPlan.packageTypeName !== ""? self.ebFtPlanEditForm.ebFtPlan.packageTypeName : target.packageTypeName;
                self.ebFtPlanEditForm.ebFtPlan.packageTypeCode = self.ebFtPlanEditForm.ebFtPlan.packageTypeCode !== ""? self.ebFtPlanEditForm.ebFtPlan.packageTypeCode : target.packageTypeCode;
                self.ebFtPlanEditForm.ebFtPlan.grossWeight = self.ebFtPlanEditForm.ebFtPlan.grossWeight !== 0? self.ebFtPlanEditForm.ebFtPlan.grossWeight : target.grossWeight;
                self.ebFtPlanEditForm.ebFtPlan.cube = self.ebFtPlanEditForm.ebFtPlan.cube !== 0? self.ebFtPlanEditForm.ebFtPlan.cube : target.cube;
                self.ebFtPlanEditForm.ebFtPlan.netWeight = self.ebFtPlanEditForm.ebFtPlan.netWeight !== ""? self.ebFtPlanEditForm.ebFtPlan.netWeight : target.netWeight;
                self.ebFtPlanEditForm.ebFtPlan.cargoDescriptionCn = self.ebFtPlanEditForm.ebFtPlan.cargoDescriptionCn !== ""? self.ebFtPlanEditForm.ebFtPlan.cargoDescriptionCn : target.cargoName;
              }
              if (self.ebFtPlanEditForm.ebFtPlan.ebFtPlanId) {
                self.ebFtPlanEditForm.ebFtPlan.rowStatus = 16;
              } else {
                self.ebFtPlanEditForm.ebFtPlan.rowStatus = 4;
              }
              if(self.ebFtPlanEditForm.ebFtPlan.ebFtPlanCtnCargos){
                self.ebFtPlanEditForm.ebFtPlan.ebFtPlanCtnCargos.forEach(function (item) {
                  if (item.ebFtPlanCtnCargoId) {
                    item.rowStatus = 16;
                  } else {
                    item.rowStatus = 4;
                  }
                });
              }
              self.ebFtPlanEditForm.ebFtPlan.ebFtPlanPartys.forEach(function (item) {
                if (item.ebFtPlanPartyId) {
                  item.rowStatus = 16;
                } else {
                  item.rowStatus = 4;
                }
              });
              if (res.records.notEditable) {
                self.ebFtPlanEditForm.ebOrder.notEditable = res.records.notEditable;
              }
            //  self.getManifestSummaryByBox(
                  //self.ebFtPlanEditForm
             //     self.ebFtPlanEditForm.ebFtPlan.ebFtPlanId
            //  );
               self.getManifestJsonSummaryByBox(
                     this.goOrderId
               );

            //  self.getManifestSummaryByTicket(
            //      self.ebFtPlanEditForm.ebFtPlan.ebFtPlanId
            //  );

               self.getManifestJsonSummaryByTicket(
                        this.goOrderId
               );

              if (self.ebFtPlanEditForm.ebFtPlan.approvalStatus === 'NEW' || self.ebFtPlanEditForm.ebFtPlan.approvalStatus === 'REJ') {
                self.submitVisible = false;
                self.isAddManiFest = true;
              } else {
                self.submitVisible = true;
                self.isAddManiFest = false;
              }
            } else {
              self.ebFtPlanEditForm.ebFtPlanPartySh = ebFtPlanPartySh;
              self.ebFtPlanEditForm.ebFtPlanPartyCn = ebFtPlanPartyCn;
              self.ebFtPlanEditForm.ebFtPlanPartyNt = ebFtPlanPartyNt;
              const ebFtPlan = {
                ebFtPlanId: null,
                approvalStatus: "NEW",
                shipAgencyId: null,
                shipAgencyName: null,
                billProperty: null,
                loadDate: null,
                placeOfDestId: null,
                placeOfDestName: null,
                manifestStatus: "NEW",
                rowStatus: 4,
                marks: null,
                cargoDescription: null,
                noOfPackage: null,
                packageTypeName: null,
                packageTypeCode: null,
                grossWeight: null,
                cube: null,
                cargoDescriptionCn: null,
              };
              self.ebFtPlanEditForm.ebFtPlan = ebFtPlan;
            }
            self.ebFtPlanEditForm.ebFtPlan.placeOfDestName = res.records.placeOfDeliveryName;
            self.ebFtPlanEditForm.ebFtPlan.placeOfDestId = res.records.placeOfDeliveryId;
          }
        });
        self.ebFtPlanEditForm.ebFtPlanPartySh = ebFtPlanPartySh;
        self.ebFtPlanEditForm.ebFtPlanPartyCn = ebFtPlanPartyCn;
        self.ebFtPlanEditForm.ebFtPlanPartyNt = ebFtPlanPartyNt;
      } else {
        self.ebFtPlanEditForm.ebFtPlanPartySh = ebFtPlanPartySh;
        self.ebFtPlanEditForm.ebFtPlanPartyCn = ebFtPlanPartyCn;
        self.ebFtPlanEditForm.ebFtPlanPartyNt = ebFtPlanPartyNt;
        const ebFtPlan = {
          ebFtPlanId: null,
          approvalStatus: "NEW",
          shipAgencyId: null,
          shipAgencyName: null,
          billProperty: null,
          loadDate: null,
          placeOfDestId: null,
          placeOfDestName: null,
          manifestStatus: "NEW",
          rowStatus: 4,
        };
        self.ebFtPlanEditForm.ebFtPlan = ebFtPlan;
        self.VGMTableDataSource = [];
        self.boxGoodsTableDataSource = [];
      }
      self.boxGoodsTableRules = boxGoodsValidate();
      self.VGMTableRules = VGMEbCtnValidate();
    },
    uploadSuccess(values) {
      console.log(values);
    },
    manifestImport(file) {
      manifestImport(file).then((res) => {
        if (res.records.success === false) {
          let message = res.records.errorMessages[0]
          this.$coreMethods.message("warning", message);
        } else {
          if (res.success && res.success === true) {
            this.ebFtPlanEditForm.ebFtPlanPartyCn = res.records.ebFtPlanPartyCn;
            this.ebFtPlanEditForm.ebFtPlanPartyCn.rowStatus = 4;
            this.ebFtPlanEditForm.ebFtPlanPartySh = res.records.ebFtPlanPartySh;
            this.ebFtPlanEditForm.ebFtPlanPartySh.rowStatus = 4;
            this.ebFtPlanEditForm.ebFtPlanPartyNt = res.records.ebFtPlanPartyNt;
            this.ebFtPlanEditForm.ebFtPlanPartyNt.rowStatus = 4;
            let ebFtPlanCtnCargo = res.records.ebFtPlanCtnCargo;

            this.boxGoodsTableDataSource = [];
            this.VGMTableDataSource = [];
            this.boxCollectTableDataSource = [];
            this.billCollectTableDataSource = [];
            ebFtPlanCtnCargo.forEach((item) => {
              item.rowStatus = 4;
              this.boxGoodsTableDataSource.push(item);
            });

             this.$coreMethods.message("success", "数据导入成功");
          }
        }
      });
    },
    validateAutoFocus() {
      // let self = this
      this.autoFocus(this.ebFtPlanEditForm.ebOrder, this.ebFtPlanEditFormRules);
    },
        // 前端表单数据校验
    validateEditFromInfo(submitType) {
      let self = this
      console.log(submitType)
      self.$refs.editFromInfoRef.editFromValidate(editFromInfoValid => {
        console.log(editFromInfoValid)
            if (editFromInfoValid){
                self.saveAndsubmit(submitType)
            } else {
              if (!editFromInfoValid) {

                self.$refs.editFromInfoRef.validateAutoFocus();
                self.$refs.editFromInfoRef.autoFocus();

                document.getElementById("check").scrollIntoView();
                self.$coreMethods.message("warning", "收发通信息校验不通过！");
              }
            }
      });
    },

    changeVgmVerifyType(value) {
      console.log(value);
      this.vgmVerifyTypeOptions.forEach((item) => {
        if (item["value"] === value) {
          this.VGMTableDataSource[this.VGMTableSelectRowIndex].vgmVerifyType =
              item.key;
        }
      });
    },
    // 数据处理
    processingDate() {
      const ebFtPlanEditForm = this.ebFtPlanEditForm;
      const VGMTableData = this.VGMTableDataSource;
      const boxGoodsTableData = this.boxGoodsTableDataSource;
      let editData = {
        ebFtPlanPartySh: ebFtPlanEditForm.ebFtPlanPartySh,
        ebFtPlanPartyCn: ebFtPlanEditForm.ebFtPlanPartyCn,
        ebFtPlanPartyNt: ebFtPlanEditForm.ebFtPlanPartyNt,
        ebOrder: ebFtPlanEditForm.ebOrder,
        ebFtPlan: ebFtPlanEditForm.ebFtPlan,
        manifestEbFtPlanCtnCargoDTOS: boxGoodsTableData,
        vgmEbCtnDTOS: VGMTableData,
      };
      return editData;
    },
    addVGMData() {
      return {
        ebCtnId: null,
        ctnNo: null,
        sealNo: null,
        ctnSizeType: null,
        vgmTareWeight: null,
        vgmWeight: null,
        vgmVerifyType: null,
        vgmVerifyTypeCn: null,
        vgmVerifyAddress: null,
        vgmVerifyDate: null,
        vgmShipperName: null,
        vgmVerifyPerson: null,
        vgmContactTel: null,
        vgmContactEmail: null,
        vgmResponsiblePersonSign: null,
        vgmVerifyCompanyContactTel: null,
        vgmVerifyCompanyContactEmail: null,
        rowStatus: 4,
      };
    },addVGMDatas() {
     if(this.boxGoodsTableDataSource && this.VGMTableDataSource){
                      this.boxGoodsTableDataSource.forEach(x => {
                        let isNewCtn = true;
                        this.VGMTableDataSource.forEach(item => {
                          if(x.ctnNo === item.ctnNo){
                            isNewCtn = false;
                          }
                        })
                        if(isNewCtn){
                          let newVGM = {
                            ebCtnId: null,
                            brokerMblNo: this.ebFtPlanEditForm.ebOrder.mblNo,
                            ctnNo: x.ctnNo,
                            sealNo: x.sealNo,
                            ctnSizeType: x.ctnSizeType,
                            vgmTareWeight: null,
                            vgmWeight: null,
                            vgmVerifyType: null,
                            vgmVerifyTypeCn: null,
                            vgmVerifyAddress: null,
                            vgmVerifyDate: null,
                            vgmShipperName: null,
                            vgmVerifyPerson: null,
                            vgmContactTel: null,
                            vgmContactEmail: null,
                            vgmResponsiblePersonSign: null,
                            vgmVerifyCompanyContactTel: null,
                            vgmVerifyCompanyContactEmail: null,
                            rowStatus: 4,
                          };
                          this.VGMTableDataSource.push(newVGM);
                        }
                      })
                    }

        },
    addboxGoodsData() {
      const ebFtPlanEditForm = this.ebFtPlanEditForm;
      return {
        ebCtnId: null,
        ebFtPlanCtnCargoId: null,
        ctnNo: null,
        sealNo: null,
        ctnSizeType: null,
        brokerMblNo: ebFtPlanEditForm.ebOrder.mblNo,
        fullEmptyStatus: null,
        cargoDescription: null,
        packageTypeCode: null,
        packageTypeName: null,
        noOfPackage: null,
        grossWeight: null,
        cube: null,
        marks: null,
        hsCode: null,
        unNo: null,
        hazardClass: null,
        urgentContract: null,
        urgentContractTel: null,
        rowStatus: 4,
      };
    },
    // VGM信息
    VGMTableCellClick(row) {
      this.$refs.VGMTableRef.startEdit(row.physicalRow, row.physicalCol);
    },
    VGMTableRowClick(value) {
      this.VGMTableSelectRowIndex = value.row;

      if (JSON.stringify(this.VGMTableRules) === '{}') this.VGMTableRules = VGMEbCtnValidate();
    },
    // vgm表格箱号修改事件
    vgmCtnNoChange(value, selectedRows) {
      console.log(selectedRows);
      let self = this;
      const VGMTableSelectRowData =
          this.VGMTableDataSource[this.VGMTableSelectRowIndex];
      //订舱编辑，存在相应的vgm数据
      if (self.ebFtPlanEditForm.ebOrder.ebOrderId) {
        for (const key in VGMTableSelectRowData) {
          VGMTableSelectRowData[key] = selectedRows[key];
        }
      }

      if (VGMTableSelectRowData.vgmVerifyDate) {
        console.log(new Date(VGMTableSelectRowData.vgmVerifyDate));
        VGMTableSelectRowData.vgmVerifyDate = this.$moment(
            VGMTableSelectRowData.vgmVerifyDate
        ).format("yyyy-MM-DD HH:mm:ss");
      }
    },
    VGMAdd() {
      this.addVGMDatas();
     // this.VGMTableDataSource.push(this.addVGMData());
      if (JSON.stringify(this.VGMTableRules) === '{}') this.VGMTableRules = VGMEbCtnValidate();
    },
    VGMCopy() {
      const selections = this.$refs.VGMTableRef.getSelections();
      if (selections && selections.length > 1) {
        this.$coreMethods.message("warning", "最多只能勾选一条记录");
      } else if (selections && selections.length === 1) {
        console.log(selections[0])
        this.VGMTableDataSource.forEach(item => {
          if (selections[0] !== item) {
            item.vgmVerifyTypeCn = selections[0].vgmVerifyTypeCn
            item.vgmVerifyType = selections[0].vgmVerifyType
            item.vgmVerifyAddress = selections[0].vgmVerifyAddress
            item.vgmVerifyDate = selections[0].vgmVerifyDate
            item.vgmShipperName = selections[0].vgmShipperName
            item.vgmVerifyPerson = selections[0].vgmVerifyPerson
            item.vgmContactTel = selections[0].vgmContactTel
            item.vgmContactEmail = selections[0].vgmContactEmail
          }
        })
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
    },
    VGMDelete() {
      const selections = this.$refs.VGMTableRef.getSelections();
      let ebCtnDeleteIds = [];
      let indexList = [];
      let VGMTableDataSource = this.VGMTableDataSource;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.ebCtnId) {
            ebCtnDeleteIds.push(selection.ebCtnId);
          }
          const index = VGMTableDataSource.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      //删除逻辑
      if (ebCtnDeleteIds && ebCtnDeleteIds.length > 0) {
       let delParams={
              goCtnIds:ebCtnDeleteIds,
              goOrderId:this.goOrderId
            }

       this.$coreMethods.confirm(
            function () {
             delectGoCtnById(delParams).then((res) => {
               if (res.success) {
                  let offset = 0;
                  indexList.forEach((index) => {
                  VGMTableDataSource.splice(index - offset, 1);
                   offset++;
                 });
              }
             });
             },
              null,
               false,
               "删除VGM信息会删除所有关联的箱信息， 是否继续？",
                "提示"
          );




      /*
        queryEbCtnRelation(ebCtnDeleteIds).then((res) => {
          if (res.success) {
            delectEbCtnById(ebCtnDeleteIds).then((res) => {
              if (res.success) {
                let offset = 0;
                indexList.forEach((index) => {
                  VGMTableDataSource.splice(index - offset, 1);
                  offset++;
                });
              }
            });
          } else {
            const _this = this;
            this.$coreMethods.confirm(
                function () {
                  delectEbCtnById(ebCtnDeleteIds).then((res) => {
                    if (res.success) {
                      let offset = 0;
                      indexList.forEach((index) => {
                        VGMTableDataSource.splice(index - offset, 1);
                        offset++;
                      });
                      console.log("success");
                      // _this.reload()
                    }
                  });
                },
                null,
                false,
                "删除VGM信息会删除所有关联的箱信息， 是否继续？",
                "提示"
            );
          }
        }); */

      } else {
        let offset = 0;
        indexList.forEach((index) => {
          VGMTableDataSource.splice(index - offset, 1);
          offset++;
        });
      }
    },
    // 获取数据字典
    getSelectList() {
      queryDictRows(
          "MD_CODE_DICT$VGM_VERIFY_TYPE,MD_CODE_DICT$FCL_LCL"
      ).then((res) => {
        /*name:value value:key*/
        //称重方式
        this.vgmVerifyTypeOptions = res.MD_CODE_DICT$VGM_VERIFY_TYPE;
        this.fullEmptyStatusOptions = res.MD_CODE_DICT$FCL_LCL;
        let dict = [];
        res.MD_CODE_DICT$VGM_VERIFY_TYPE.forEach((item) => {
          let param = {};
          param.name = item.value;
          param.value = item.key;
          param.count = 0;
          param.filterList = []
          dict.push(param);
        });
        this.$hotTableUtils.registDict({
          VGM_VERIFY_TYPE: dict,
        });
        this.setDictionaries();
      });
    },
    //数据字典
    setDictionaries() {
      let dict = [];
      this.vgmVerifyTypeOptions.forEach((item) => {
        let param = {};
        param.name = item.label;
        param.value = item.value;
        param.count = 0;
        dict.push(param);
      });
      this.$hotTableUtils.registDict({ EB_CTN_VGM_VERIFY_TYPE: dict });

      dict = [];
      this.fullEmptyStatusOptions.forEach((item) => {
        let param = {};
        param.name = item.value;
        param.value = item.key;
        param.count = 0;
        dict.push(param);
      });
      this.$hotTableUtils.registDict({ FCL_LCL: dict });
    },
    // 箱号联想控件数据源
    associate_queryMethod_ctnNo({ keyword, pageSize, currentPage }) {

    var goOrderId=-999;
    if(this.goOrderId){
      goOrderId=this.goOrderId;
    }


      let params = {
        currentPage: currentPage,
        pageSize: pageSize,
        ctnNo: keyword,
        goOrderId: goOrderId
      };
      let no = [];
      if (this.ebFtPlanEditForm.ebOrder.ebCtns && this.ebFtPlanEditForm.ebOrder.ebCtns.length > 0) {
        this.ebFtPlanEditForm.ebOrder.ebCtns.forEach(item => {
          //过滤主系统的数据
            no.push(item);
        })
      }
      let data = {
              action: "query",
              crudType: "SELECT",
              mainModelName: "GoCtn",
              tag: "DS_cts-manager_GoCtn_query",
              where: "GoCtn.goOrderId = :goOrderId",
              currentPage: currentPage,
              pageSize: pageSize,
              returnPage: true,
              returnTotal: false,
              reqArgs: params,
              fields: ["GoCtn.ctnNo"],
              enableCascade: true,
            };

      return new Promise((resolve) => {
       queryGoCtnInfo(data).then((res) => {
                 console.log("queryGoCtnInfo", res);
                 resolve({
                   records: res.data.data,
                   total: res.data.totalRecord,
                 });
               });
      }).catch((err) => {
        console.log(err);
      });

    },
    // 箱型尺寸联想控件数据源
    associate_queryMethod_ctnSizeType({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted2: "0",
          isActive: "1",
        };
      } else {
        params = {
          isDeleted0: "%" + keyword + "%",
          containerType1: "%" + keyword + "%",
          isDeleted2: "0",
          isActive: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdContainerType.containerType"],
        mainModelName: "CTS_ILPMdContainerType",
        tag: "CTS_ILP_es",
        where:
            "((CTS_ILPMdContainerType.isDeleted LIKE :isDeleted0 OR CTS_ILPMdContainerType.containerType LIKE :containerType1) AND CTS_ILPMdContainerType.isDeleted = :isDeleted2 AND CTS_ILPMdContainerType.isActive = :isActive)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.mdContainerTypeId",
          "CTS_ILPMdContainerType.containerTypeName",
          "CTS_ILPMdContainerType.recordVersion",
          "CTS_ILPMdContainerType.ctnHeight",
          "CTS_ILPMdContainerType.principalGroupCode",
          "CTS_ILPMdContainerType.lastModifierId",
          "CTS_ILPMdContainerType.ctnWeight",
          "CTS_ILPMdContainerType.lastModifyOffice",
          "CTS_ILPMdContainerType.creatorName",
          "CTS_ILPMdContainerType.createOffice",
          "CTS_ILPMdContainerType.teu",
          "CTS_ILPMdContainerType.isActive",
          "CTS_ILPMdContainerType.creatorId",
          "CTS_ILPMdContainerType.createTime",
          "CTS_ILPMdContainerType.lastModifyOfficeName",
          "CTS_ILPMdContainerType.ctnWidth",
          "CTS_ILPMdContainerType.containerSize",
          "CTS_ILPMdContainerType.lastModifyTime",
          "CTS_ILPMdContainerType.ctnDescriptionEn",
          "CTS_ILPMdContainerType.ctnDescriptionCn",
          "CTS_ILPMdContainerType.maxWeight",
          "CTS_ILPMdContainerType.containerType",
          "CTS_ILPMdContainerType.ctnLength",
          "CTS_ILPMdContainerType.lastModifierName",
          "CTS_ILPMdContainerType.isDeleted",
          "CTS_ILPMdContainerType.appCode",
          "CTS_ILPMdContainerType.maxMeas",
          "CTS_ILPMdContainerType.reamrk",
          "CTS_ILPMdContainerType.createOfficeName",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryCtnSizeInfo(data).then((res) => {
          console.log("queryCtnSizeInfo", res);
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //包装联想控件数据源
    associate_queryMethod_packageType({ keyword, pageSize, currentPage }) {
      let params = {};
      if (keyword === "") {
        params = {
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      } else {
        params = {
          mdChargeunitCode0: "%" + keyword + "%",
          enName1: "%" + keyword + "%",
          cnName2: "%" + keyword + "%",
          isDeleted3: "0",
          isActive4: "1",
          isPackageType5: "1",
        };
      }

      let data = {
        action: "query",
        crudType: "SELECT",
        sorting: ["CTS_ILPMdChargeunit.cnName"],
        mainModelName: "CTS_ILPMdChargeunit",
        tag: "CTS_ILP_es",
        where:
            "(((((CTS_ILPMdChargeunit.mdChargeunitCode LIKE :mdChargeunitCode0 OR CTS_ILPMdChargeunit.enName LIKE :enName1) OR CTS_ILPMdChargeunit.cnName LIKE :cnName2) AND CTS_ILPMdChargeunit.isDeleted = :isDeleted3) AND CTS_ILPMdChargeunit.isActive = :isActive4) AND CTS_ILPMdChargeunit.isPackageType = :isPackageType5)",
        currentPage: currentPage,
        pageSize: pageSize,
        returnPage: true,
        returnTotal: false,
        reqArgs: params,
        fields: [
          "CTS_ILPMdChargeunit.mdChargeunitId",
          "CTS_ILPMdChargeunit.creatorName",
          "CTS_ILPMdChargeunit.isDeleted",
          "CTS_ILPMdChargeunit.lastModifyOfficeName",
          "CTS_ILPMdChargeunit.isChargeUnit",
          "CTS_ILPMdChargeunit.lastModifyTime",
          "CTS_ILPMdChargeunit.isContainerSize",
          "CTS_ILPMdChargeunit.creatorId",
          "CTS_ILPMdChargeunit.createOffice",
          "CTS_ILPMdChargeunit.lastModifyOffice",
          "CTS_ILPMdChargeunit.deptOfficeName",
          "CTS_ILPMdChargeunit.isPackageUnit",
          "CTS_ILPMdChargeunit.enName",
          "CTS_ILPMdChargeunit.isActive",
          "CTS_ILPMdChargeunit.recordVersion",
          "CTS_ILPMdChargeunit.relateCode",
          "CTS_ILPMdChargeunit.principalGroupCode",
          "CTS_ILPMdChargeunit.settleOfficeName",
          "CTS_ILPMdChargeunit.deptOffice",
          "CTS_ILPMdChargeunit.isPackageType",
          "CTS_ILPMdChargeunit.lastModifierId",
          "CTS_ILPMdChargeunit.cnName",
          "CTS_ILPMdChargeunit.ebMdChargeunitId",
          "CTS_ILPMdChargeunit.isWeightUnit",
          "CTS_ILPMdChargeunit.createOfficeName",
          "CTS_ILPMdChargeunit.createTime",
          "CTS_ILPMdChargeunit.isCubeUnit",
          "CTS_ILPMdChargeunit.settleOffice",
          "CTS_ILPMdChargeunit.mdChargeunitCode",
          "CTS_ILPMdChargeunit.lastModifierName",
          "CTS_ILPMdChargeunit.isAreaUnit",
          "CTS_ILPMdChargeunit.remark",
        ],
        enableCascade: true,
      };
      return new Promise((resolve) => {
        queryPackageInfo(data).then((res) => {
          resolve({
            records: res.data.data,
            total: res.data.totalRecord,
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    queryAeoCode(data, type) {
      let self = this;
      queryCountry(data).then(res => {
        if (type === "SH") {
          self.aeoCodeSh = res.records.aeoCodeType.split(",");
        } else if (type === "CN") {
          self.aeoCodeCn = res.records.aeoCodeType.split(",");
        } else if (type === "NT") {
          self.aeoCodeNt = res.records.aeoCodeType.split(",");
        } else {
          this.$coreMethods.message("warning", "收发通类型错误请检查！");
        }
      });
    },
    // 箱货明细
    boxGoodsTableCellClick(row) {
      this.$refs.boxGoodsTableRef.startEdit(row.physicalRow, row.physicalCol);
    },
    boxGoodsTableRowClick(value) {
      this.boxGoodsTableSelectRowIndex = value.row;
    },
    boxGoodsAdd() {
      this.boxGoodsTableDataSource.push(this.addboxGoodsData());
    },
    //引用
    boxGoodsQuote() {
      let self = this;
      const mblNo = this.ebFtPlanEditForm.ebOrder.mblNo;
      let newboxGoodsTableData = [];
      // if (ebOrderId !== null) {
      //   ebCtn.getEbCtnByEbOrderId(ebOrderId).then((res) => {
      //     if (res.success) {
      //       //res.data[0].brokerMblNo = mblNo;
      //       res.data.forEach((data) => {
      //         data.brokerMblNo = mblNo;
      //       });
      //       this.boxGoodsTableDataSource = res.data;
      //     }
      //   });
      // }
      if(self.boxGoodsTableDataSource && self.boxGoodsTableDataSource.length > 0){
        self.$confirm("引用后，会覆盖当前箱货信息，是否继续？", '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          if (self.ebFtPlanEditForm.ebOrder.ebCtns) {
            self.ebFtPlanEditForm.ebOrder.ebCtns.forEach(item => {
              let newRow = {
                ebCtnId: item.ebCtnId,
                ebFtPlanCtnCargoId: null,
                ctnNo: item.ctnNo,
                sealNo: item.sealNo,
                ctnSizeType: item.ctnSizeType,
                brokerMblNo: mblNo,
                fullEmptyStatus: null,
                cargoDescription: null,
                packageTypeCode: null,
                packageTypeName: null,
                noOfPackage: null,
                grossWeight: null,
                cube: null,
                marks: null,
                hsCode: null,
                unNo: null,
                hazardClass: null,
                urgentContract: null,
                urgentContractTel: null,
                rowStatus: 4,
              }
              newboxGoodsTableData.push(newRow);
            });
            self.boxGoodsTableDataSource = newboxGoodsTableData;
          }
        });
      }else {
        if (self.ebFtPlanEditForm.ebOrder.ebCtns) {
          self.ebFtPlanEditForm.ebOrder.ebCtns.forEach(item => {
            let newRow = {
              ebCtnId: item.ebCtnId,
              ebFtPlanCtnCargoId: null,
              ctnNo: item.ctnNo,
              sealNo: item.sealNo,
              ctnSizeType: item.ctnSizeType,
              brokerMblNo: mblNo,
              fullEmptyStatus: null,
              cargoDescription: null,
              packageTypeCode: null,
              packageTypeName: null,
              noOfPackage: null,
              grossWeight: null,
              cube: null,
              marks: null,
              hsCode: null,
              unNo: null,
              hazardClass: null,
              urgentContract: null,
              urgentContractTel: null,
              rowStatus: 4,
            }
            newboxGoodsTableData.push(newRow);
          });
          self.boxGoodsTableDataSource = newboxGoodsTableData;
        }
      }
    },

    boxGoodsCopy() {
      console.log(this.ebFtPlanEditForm);
      const selections = this.$refs.boxGoodsTableRef.getSelections();
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          const data = {
            ...selection,
          };
          data.ebCtnId = null;
          data.ebFtPlanCtnCargoId = null;
          this.boxGoodsTableDataSource.push(data);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
    },
    boxGoodsDelete() {
      const selections = this.$refs.boxGoodsTableRef.getSelections();
      let ebFtPlanCtnCargoDeleteIds = [];
      let indexList = [];
      let boxGoodsTableDataSource = this.boxGoodsTableDataSource;
      if (selections && selections.length > 0) {
        selections.forEach((selection) => {
          if (selection.ebFtPlanCtnCargoId) {
            ebFtPlanCtnCargoDeleteIds.push(selection.ebFtPlanCtnCargoId);
          }
          const index = boxGoodsTableDataSource.indexOf(selection);
          indexList.push(index);
        });
      } else {
        this.$coreMethods.message("warning", "请勾选一条记录");
      }
      //删除逻辑
      if (ebFtPlanCtnCargoDeleteIds && ebFtPlanCtnCargoDeleteIds.length > 0) {
        deteleEbFtPlanCtnCargoById(ebFtPlanCtnCargoDeleteIds).then((res) => {
          if (res.success) {
            let offset = 0;
            indexList.forEach((index) => {
              boxGoodsTableDataSource.splice(index - offset, 1);
              offset++;
            });
          }
        });
      } else {
        let offset = 0;
        indexList.forEach((index) => {
          boxGoodsTableDataSource.splice(index - offset, 1);
          offset++;
        });
      }
    },

    boxGoodsCite() {
      let self = this;
      let data;
      const ebFtPlanEditForm = this.ebFtPlanEditForm;
      const VGMTableData = this.VGMTableDataSource;
      const boxGoodsTableData = this.boxGoodsTableDataSource;
      if (VGMTableData !== null) {
        self.boxGoodsTableDataSource = VGMTableData;
        this.boxGoodsTableDataSource.push(this.addboxGoodsData());
      }
      self.VGMTableDataSource = data.ebCtns;
      self.boxGoodsTableDataSource = data.ebFtPlan.ebFtPlanCtnCargos;
      self.boxGoodsTableDataSource.forEach(function (ebFtPlanCtnCargo) {
        data.ebCtns.forEach(function (ebCtn) {
          if (ebFtPlanCtnCargo.ebCtnId === ebCtn.ebCtnId) {
            ebFtPlanCtnCargo.ctnNo = ebCtn.ctnNo;
            ebFtPlanCtnCargo.sealNo = ebCtn.sealNo;
            ebFtPlanCtnCargo.ctnSizeType = ebCtn.ctnSizeType;
            ebFtPlanCtnCargo.fullEmptyStatus = ebCtn.fullEmptyStatus;
          }
        });
      });
    },
    sealNoChange(){

    },
    // 箱货表格箱号修改事件
    boxCtnNoChange(value, selectedRows) {
      const boxGodTableSelectRowData = this.boxGoodsTableDataSource[this.boxGoodsTableSelectRowIndex];
      if(selectedRows.ebCtnId !==undefined){
        boxGodTableSelectRowData.ebCtnId = selectedRows.ebCtnId;
        boxGodTableSelectRowData.ctnNo = selectedRows.ctnNo;
        boxGodTableSelectRowData.sealNo = selectedRows.sealNo;
        boxGodTableSelectRowData.ctnSizeType = selectedRows.ctnSizeType;
      }else{
        if(selectedRows.ctnNo===""){
          boxGodTableSelectRowData.ebCtnId = null;
          boxGodTableSelectRowData.sealNo = null;
          boxGodTableSelectRowData.ctnSizeType = null;
        }else{
          boxGodTableSelectRowData.ebCtnId = null;
          boxGodTableSelectRowData.ctnNo = selectedRows.ctnNo;
          boxGodTableSelectRowData.sealNo = selectedRows.sealNo;
          boxGodTableSelectRowData.ctnSizeType = selectedRows.ctnSizeType;
        }
      }
    },
    //包装联想控件修改事件
    boxPackageTypeChange(value, selectedRows) {
      const boxGodTableSelectRowData =
          this.boxGoodsTableDataSource[this.boxGoodsTableSelectRowIndex];
      boxGodTableSelectRowData.packageTypeCode = selectedRows.mdChargeunitCode;
    },
    // 箱货明细结束
    // 箱信息汇总
    boxCollectTableCellClick() {
    },
    boxCollectTableRowClick() {
    },
    // 提单箱信息汇总
    billCollectTableCellClick() {
    },
    billCollectTableRowClick() {
    },
    closeTab() {
      const index = this.$store.getters.visitedViews.findIndex((page) => {
        return page.name === "manifestAdd";
      });
      if (index >= 0) {
        // 更新数据 删除关闭的页面
        this.$store.getters.visitedViews.splice(index, 1);
        this.$router.push("/");
        this.$destroy();
      }
      }, downLoadFile(){  //打开导入模板下载页面
          let self = this;
          this.downloadVisible= true;

          let searchData = {
             apiKey : "CTS_ILP_MdReportTemplate",
              sqlKey: "CTS_ILP_MdReportTemplate",
                       tag: "CTS_ILP_MdReportTemplate",
                       reqArgs: {"templateTypeCode": "WEB_TEMPLATE"},
                       action: "query",
                       returnTotal: false
                    }
                   queryMdReportTemplate(searchData).then((res) => {
                    console.log("queryEbOrder", res);
                      if (res.success == true ) {
                          this.mdReportTemplateData = res.data;
                        if (res.data.length === 0){
                           this.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
                        }else {
                                this.$coreMethods.message("success", "查询成功！");
                             }
                           }
             });


      } ,download(){//下载选中的导入模板

                 let self = this;

                 if(this.$refs.mdReportTemplateRef.getSelections().length!=0){
                  var size=this.$refs.mdReportTemplateRef.getSelections().length;

                  for(var i=0;i<size;i++){
                      var url=this.$refs.mdReportTemplateRef.getSelections()[i].reportUrl;
                      var name=this.$refs.mdReportTemplateRef.getSelections()[i].templateNameCn;
                      //document.getElementById(key).click();
                       var a = document.createElement("a");
                         a.download = name + ".xlsx";
                         a.href = url;
                         a.click();
                  }

                 }else {
                   this.$coreMethods.message("warning", "请勾选要下载的模板！");
                 }
               }
    , paste(){
            let self = this;
            this.pasteVisible= true;
      },
      closePaste(){
            this.pasteVisible= false;
       },importPaste(){
          console.log(this.pasteForm.markReason);


					var checkList =this.pasteForm.markReason;
					let map = new Map();
					map.set("提单号","brokerMblNo");
					map.set("箱号","ctnNo");
					map.set("封号","sealNo");
					map.set("箱型","ctnSizeType");
					map.set("英文品名","cargoDescription");
					map.set("10位HScode","hsCode");
					map.set("HS","hsCode");
					map.set("HS CODE","hsCode");
					map.set("件数","noOfPackage");
					map.set("包装单位","packageTypeName");
					map.set("毛重(KGS)","grossWeight");
					map.set("体积(CBM)","cube");
					map.set("唛头","marks");
					map.set("UN Code(危)","unNo");
					map.set("类别(危)","hazardClass");
					var headerData = checkList.substring(0,checkList.indexOf("\n")).split("\t");
					var coloumns = new Map();
					for(let i=0;i<headerData.length;i++){
						if(map.get(headerData[i])!=undefined){
							coloumns.set(i,map.get(headerData[i]));
						}
					}
					if(coloumns.size==0){
						 this.$coreMethods.message("warning", "没有表头不允许导入");
						return;
					}

					let bodyData = checkList.substring(checkList.indexOf("\n")+1).split("\n");
					var records = [];
					for(let i=0;i<bodyData.length;i++){
						let dataList = bodyData[i].split("\t");
						let datas ={"rowStatus":4};
						for(let j=0;j<dataList.length;j++){
							if(coloumns.get(j)!=undefined) {
								datas[coloumns.get(j)] = dataList[j];
							}
						}
						records.push(datas);
						this.boxGoodsTableDataSource.push(datas);
					}
			  this.pasteVisible= false;

       },
     openPrint(){
         let self = this;
          this.mdReportTemplateVisible= true;
          let searchData = {
             apiKey : "CTS_ILP_MdReportTemplate",
             sqlKey: "CTS_ILP_MdReportTemplate",
             tag: "CTS_ILP_MdReportTemplate",
             reqArgs: {"templateTypeCode": "WEB_FT_PLAN"},
             action: "query",
             returnTotal: false
          }
         queryMdReportTemplate(searchData).then((res) => {
          console.log("queryEbOrder", res);
            if (res.success == true ) {
                this.mdReportTemplateData = res.data;
              if (res.data.length === 0){
                 this.$coreMethods.message("warning", "没有数据，请重新输入查询条件！");
              }else {
                      this.$coreMethods.message("success", "查询成功！");
                   }
                 }
             });
          },
          createMblConfirm(){  //生成提单确认件

              var goOrderId=fullPath.substr(fullPath.indexOf("?"),fullPath.length);
              let routeUrl = this.$router.resolve({
               path: "/billLadingEdit?"+goOrderId+"&type=FT"
               });
                 window.open(routeUrl.href, '_blank');
      },

    exportExcel(){
          let self = this;
          var fullPath = window.location.href;
          if(this.$refs.mdReportTemplateTableRef.getSelections().length==1){

            if(this.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
              this.$coreMethods.message("error", "报表路径错误，请检查！");
              return;
            }
           var ipAddress=fullPath.substring(0,fullPath.indexOf("/manifestHyperlinks"));

            var filename=this.mblNo+" 预配舱单";
            this.mdReportTemplateVisible= false;

            if(ipAddress=="https://cs.ctsfreight.com"){
            let routeUrl = this.$router.resolve({
                 path: "/webroot/decision/view/report",
                 query:{
                         reportlet:this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
                         ipAddress: "http://10.1.203.147:88",
                         primaryId: this.goOrderId,
                         fullPath:fullPath,
                         format:"excel",
                         extype:"simple",
                         __filename__:filename
                     }
               });
                window.open("https://ctsilp.ctsfreight.com"+routeUrl.href, '_blank');
           }else{
             let routeUrl = this.$router.resolve({
             path: "/webroot/decision/view/report",
               query:{
                     reportlet:this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
                     ipAddress: ipAddress,
                     primaryId: this.goOrderId,
                     fullPath:fullPath,
                     format:"excel",
                     extype:"simple",
                     __filename__:filename
                    }
                 });
               window.open(routeUrl.href, '_blank');


           }

          }else {
            this.$coreMethods.message("warning", "请勾选一条数据！");
          }
        },

    preview(){

          let self = this;
          var fullPath = window.location.href;
          if(this.$refs.mdReportTemplateTableRef.getSelections().length==1){

            if(this.$refs.mdReportTemplateTableRef.getSelected().reportUrl==null){
              this.$coreMethods.message("error", "报表路径错误，请检查！");
              return;
            }

            var ipAddress=fullPath.substring(0,fullPath.indexOf("/manifestHyperlinks"));
            this.mdReportTemplateVisible= false;
            if(ipAddress=="https://cs.ctsfreight.com"){
             let routeUrl = this.$router.resolve({
               path: "/webroot/decision/view/report",
                 query:{
                       reportlet:this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
                       ipAddress: "http://10.1.203.147:88",
                        primaryId: this.goOrderId,
                        fullPath:fullPath
                       }
                 });
                 window.open("https://ctsilp.ctsfreight.com"+routeUrl.href, '_blank');
            }else{
            let routeUrl = this.$router.resolve({
              path: "/webroot/decision/view/report",
               query:{
                   reportlet:this.$refs.mdReportTemplateTableRef.getSelected().reportUrl,
                   ipAddress:ipAddress,
                   primaryId: this.goOrderId,
                   fullPath:fullPath
                   }
               });
              window.open( routeUrl.href, '_blank');

            }



          }else {
            this.$coreMethods.message("warning", "请勾选一条数据！");
          }
        },
  },
  directives: {
    update: {
      upperCase: function (el) {
        console.log(el);
      },
    },
  },



};
</script>

<style scoped lang="scss">
.el-scrollbar ::v-deep .el-scrollbar__wrap {
  height: 125px;

  .el-scrollbar__view {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .node-content {
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 220px;

      .node-content-img {
        width: 50px;
        background-size: 100% 100%;
      }

      .solid-style {
        height: 1px;
        border-top: 2px solid #e58660;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .dashed-style {
        height: 1px;
        border-top: 2px solid #d7d7d7;
        width: 173px;
        position: absolute;
        top: 30px;
        left: 134px;
      }

      .node-content-name {
        margin-top: 4px;
      }

      .node-content-date {
        font-size: 12px;
        margin-top: 4px;
        width: 80px;
        text-align: center;
        white-space: pre-wrap;
      }
    }
  }
}

.status-container {
  .status-title {
    height: 30px;
    line-height: 30px;
    text-align: center;
    background-color: #ecf4ff;
    border-right: 1px solid #ffffff;
  }

  .status-content-list {
    padding: 6px 0px;

    .status-content-item {
      text-align: center;
    }
  }

  ::v-deep .el-collapse {
    margin-top: 5px;

    .el-collapse-item {
      width: 100%;

      .el-collapse-item__content {
        padding-bottom: 0px;
        background-color: #f2f2f2;
      }

      .el-collapse-item__header {
        font-size: 14px;
        color: #2f5597;
        background-color: #f2f2f2;
        height: 30px;

        .header-icon {
          margin: 3px 0px 0px 3px;
        }
      }
    }
  }
}
</style>
